import React from "react"
import './graphic.css'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="freepik_stories-server"
      className="animated"
      version="1.1"
      viewBox="0 0 500 500"
    >
      <g
        id="freepik--background-complete--inject-32"
        className="animable"
        style={{
          WebkitTransformOrigin: 251.535,
          MsTransformOrigin: 251.535,
          transformOrigin: 251.535,
        }}
      >
        <path
          style={{
            WebkitTransformOrigin: 430.65,
            MsTransformOrigin: 430.65,
            transformOrigin: 430.65,
          }}
          id="ely8ql9okxake"
          fill="#EBEBEB"
          d="M417.41 60.85H443.89000000000004V72.04H417.41z"
          className="animable"
          transform="rotate(-180)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 445.42,
            MsTransformOrigin: 445.42,
            transformOrigin: 445.42,
          }}
          id="elae2dexdrvr5"
          fill="#EBEBEB"
          d="M432.18 46.74H458.66V57.93H432.18z"
          className="animable"
          transform="rotate(180)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 130.38,
            MsTransformOrigin: 130.38,
            transformOrigin: 130.38,
          }}
          id="elt2ij7mebzb"
          fill="#EBEBEB"
          d="M117.14 229.02H143.62V240.21H117.14z"
          className="animable"
          transform="rotate(180)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 145.16,
            MsTransformOrigin: 145.16,
            transformOrigin: 145.16,
          }}
          id="el9h1q9thyvxb"
          fill="#EBEBEB"
          d="M131.92 214.91H158.39999999999998V226.1H131.92z"
          className="animable"
          transform="rotate(180)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 159.87,
            MsTransformOrigin: 159.87,
            transformOrigin: 159.87,
          }}
          id="elggrlghtfyl"
          fill="#EBEBEB"
          d="M146.63 229.02H173.10999999999999V240.21H146.63z"
          className="animable"
          transform="rotate(180)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 54.58,
            MsTransformOrigin: 54.58,
            transformOrigin: 54.58,
          }}
          id="elqnupcq3av0n"
          fill="#EBEBEB"
          d="M41.34 46.74H67.82000000000001V57.93H41.34z"
          className="animable"
          transform="rotate(180)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 69.35,
            MsTransformOrigin: 69.35,
            transformOrigin: 69.35,
          }}
          id="elq8nnx6e3ure"
          fill="#EBEBEB"
          d="M56.11 329.85H82.59V341.04H56.11z"
          className="animable"
          transform="rotate(180)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 54.58,
            MsTransformOrigin: 54.58,
            transformOrigin: 54.58,
          }}
          id="ely4ua82ew27"
          fill="#EBEBEB"
          d="M41.34 315.74H67.82000000000001V326.93H41.34z"
          className="animable"
          transform="rotate(180)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 430.65,
            MsTransformOrigin: 430.65,
            transformOrigin: 430.65,
          }}
          id="elvaeombm7g7"
          fill="#EBEBEB"
          d="M417.41 329.85H443.89000000000004V341.04H417.41z"
          className="animable"
          transform="rotate(-180)"
        ></path>
        <circle
          cx="114.34"
          cy="84.59"
          r="32.2"
          style={{
            WebkitTransformOrigin: 114.34,
            MsTransformOrigin: 114.34,
            transformOrigin: 114.34,
          }}
          id="elchtgeirin75"
          fill="#EBEBEB"
          className="animable"
          transform="rotate(-45)"
        ></circle>
        <circle
          cx="115.82"
          cy="85.31"
          r="30.72"
          style={{
            WebkitTransformOrigin: 115.82,
            MsTransformOrigin: 115.82,
            transformOrigin: 115.82,
          }}
          id="elrmua1ffbbb8"
          fill="#DBDBDB"
          className="animable"
          transform="rotate(-57.92)"
        ></circle>
        <circle
          cx="115.82"
          cy="85.31"
          r="28.78"
          style={{
            WebkitTransformOrigin: 115.82,
            MsTransformOrigin: 115.82,
            transformOrigin: 115.82,
          }}
          id="els62acn41bbo"
          fill="#FFF"
          className="animable"
          transform="rotate(-22.29)"
        ></circle>
        <path
          d="M144 79.2c-13.11 7.94-34.65 21-46.69 28.11a28.68 28.68 0 01-7.91-10.57l39.82-36.91A28.86 28.86 0 01144 79.2z"
          style={{
            WebkitTransformOrigin: 116.7,
            MsTransformOrigin: 116.7,
            transformOrigin: 116.7,
          }}
          id="elcwny2ymz5ul"
          fill="#EBEBEB"
          className="animable"
          opacity="0.5"
        ></path>
        <path
          d="M144.58 86.32a28.52 28.52 0 01-1.9 9.35l-35.9 17a28.9 28.9 0 01-4.53-2c10.84-6.24 30.66-17.67 42.33-24.35z"
          style={{
            WebkitTransformOrigin: 123.415,
            MsTransformOrigin: 123.415,
            transformOrigin: 123.415,
          }}
          id="elajis4l9zwag"
          fill="#EBEBEB"
          className="animable"
          opacity="0.5"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 115.82,
            MsTransformOrigin: 115.82,
            transformOrigin: 115.82,
          }}
          id="elgwvfw1bfm8f"
          fill="#C7C7C7"
          d="M115.54 58.62H116.10000000000001V62.98H115.54z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 103.57,
            MsTransformOrigin: 103.57,
            transformOrigin: 103.57,
          }}
          id="elg46mpzi7gl"
          fill="#C7C7C7"
          d="M103.29 61.9H103.85000000000001V66.26H103.29z"
          className="animable"
          transform="rotate(-30)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 94.59,
            MsTransformOrigin: 94.59,
            transformOrigin: 94.59,
          }}
          id="elhgjdn882fxd"
          fill="#C7C7C7"
          d="M94.31 70.87H94.87V75.23H94.31z"
          className="animable"
          transform="rotate(-60)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 91.31,
            MsTransformOrigin: 91.31,
            transformOrigin: 91.31,
          }}
          id="eldjfzeb0lb0l"
          fill="#C7C7C7"
          d="M89.13 85.03H93.49V85.59H89.13z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 94.59,
            MsTransformOrigin: 94.59,
            transformOrigin: 94.59,
          }}
          id="eloaov3j9efim"
          fill="#C7C7C7"
          d="M92.41 97.29H96.77V97.85000000000001H92.41z"
          className="animable"
          transform="rotate(-30)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 103.56,
            MsTransformOrigin: 103.56,
            transformOrigin: 103.56,
          }}
          id="el5cmey0z5dlu"
          fill="#C7C7C7"
          d="M101.38 106.26H105.74V106.82000000000001H101.38z"
          className="animable"
          transform="rotate(-60.03)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 115.82,
            MsTransformOrigin: 115.82,
            transformOrigin: 115.82,
          }}
          id="elinsazaizjj"
          fill="#C7C7C7"
          d="M115.54 107.64H116.10000000000001V112H115.54z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 128.08,
            MsTransformOrigin: 128.08,
            transformOrigin: 128.08,
          }}
          id="elrfufmyrmn0a"
          fill="#C7C7C7"
          d="M127.8 104.36H128.35999999999999V108.72H127.8z"
          className="animable"
          transform="rotate(-30)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 137.05,
            MsTransformOrigin: 137.05,
            transformOrigin: 137.05,
          }}
          id="ellt2tcczsw9"
          fill="#C7C7C7"
          d="M136.77 95.39H137.33V99.75H136.77z"
          className="animable"
          transform="rotate(-60)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 140.33,
            MsTransformOrigin: 140.33,
            transformOrigin: 140.33,
          }}
          id="el4nz5fhxw2t5"
          fill="#C7C7C7"
          d="M138.15 85.03H142.51000000000002V85.59H138.15z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 137.05,
            MsTransformOrigin: 137.05,
            transformOrigin: 137.05,
          }}
          id="elusu4w7gphnb"
          fill="#C7C7C7"
          d="M134.87 72.78H139.23000000000002V73.34H134.87z"
          className="animable"
          transform="rotate(-30.01)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 128.07,
            MsTransformOrigin: 128.07,
            transformOrigin: 128.07,
          }}
          id="elnik6bb3qt29"
          fill="#C7C7C7"
          d="M125.89 63.81H130.25V64.37H125.89z"
          className="animable"
          transform="rotate(-60.02)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 115.815,
            MsTransformOrigin: 115.815,
            transformOrigin: 115.815,
          }}
          id="eljznzquvo04s"
          fill="#C7C7C7"
          d="M116.24 60.59L117.18 87.25 114.45 87.22 115.5 60.59 116.24 60.59z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 123.22,
            MsTransformOrigin: 123.22,
            transformOrigin: 123.22,
          }}
          id="el6zzz69jnulg"
          fill="#A6A6A6"
          d="M132.84 76.02L114.91 87.46 113.6 85.06 132.49 75.36 132.84 76.02z"
          className="animable"
        ></path>
        <path
          d="M116.75 85.31a.93.93 0 11-.93-.93.93.93 0 01.93.93z"
          style={{
            WebkitTransformOrigin: 115.82,
            MsTransformOrigin: 115.82,
            transformOrigin: 115.82,
          }}
          id="el33ok6jmv7bs"
          fill="#C7C7C7"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 231.415,
            MsTransformOrigin: 231.415,
            transformOrigin: 231.415,
          }}
          id="eluqrksew4fti"
          fill="#C7C7C7"
          d="M203.2 175.69H259.63V392.48H203.2z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 311.56,
            MsTransformOrigin: 311.56,
            transformOrigin: 311.56,
          }}
          id="el29q6u38mfwv"
          fill="#EBEBEB"
          d="M259.63 175.69H363.49V392.48H259.63z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 312.21,
            MsTransformOrigin: 312.21,
            transformOrigin: 312.21,
          }}
          id="eljcijkgmlrw8"
          fill="#DBDBDB"
          d="M267.42 364.88H357V385.57H267.42z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="eld27s2ys7ptw"
          fill="#EBEBEB"
          d="M271.19 368.3H322.18V370.05H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elmxw1x44zcqj"
          fill="#EBEBEB"
          d="M271.19 371.32H322.18V373.07H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elhl3nivvywpb"
          fill="#EBEBEB"
          d="M271.19 374.35H322.18V376.1H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="el2wt7d3jg3kw"
          fill="#EBEBEB"
          d="M271.19 377.38H322.18V379.13H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="eldjkewcazq3"
          fill="#EBEBEB"
          d="M271.19 380.4H322.18V382.15H271.19z"
          className="animable"
        ></path>
        <path
          d="M331.47 370a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="elluiinobliko"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M337.18 370a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="elli91tn02oa"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 370a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="eldz27exfylq5"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 370a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="ele6bivgm21l8"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M354.31 370a1.74 1.74 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 352.57,
            MsTransformOrigin: 352.57,
            transformOrigin: 352.57,
          }}
          id="elmfo4ih4ot2p"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M331.47 375.22a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="ele0p2ncpca6n"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M337.18 375.22a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="elo31inch1qgj"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 375.22a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="elvdy7edsu1m"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 375.22a1.73 1.73 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="elc49wwzsog2h"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M354.31 375.22a1.74 1.74 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 352.57,
            MsTransformOrigin: 352.57,
            transformOrigin: 352.57,
          }}
          id="el9pqql6fqdu9"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M331.47 380.42a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="el0d037wznq27"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M337.18 380.42a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="eldqmpugj82ra"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 380.42a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="eldxwnuods9w6"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 380.42a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="elkco6oj38eil"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M354.31 380.42a1.74 1.74 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 352.57,
            MsTransformOrigin: 352.57,
            transformOrigin: 352.57,
          }}
          id="elhjqxct9oo7p"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 325.23,
            MsTransformOrigin: 325.23,
            transformOrigin: 325.23,
          }}
          id="el4nu93i9ffu8"
          fill="#C7C7C7"
          d="M324.73 368.3H325.73V382.15000000000003H324.73z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 312.21,
            MsTransformOrigin: 312.21,
            transformOrigin: 312.21,
          }}
          id="elb1ohbcnv5qd"
          fill="#DBDBDB"
          d="M267.42 339.95H357V360.64H267.42z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elfmbeye8lrrh"
          fill="#EBEBEB"
          d="M271.19 343.36H322.18V345.11H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="el1hp44hy0fzo"
          fill="#EBEBEB"
          d="M271.19 346.39H322.18V348.14H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elh9cbnowdf2a"
          fill="#EBEBEB"
          d="M271.19 349.42H322.18V351.17H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="el7tyhegnqyvv"
          fill="#EBEBEB"
          d="M271.19 352.44H322.18V354.19H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="el7462qyiby6l"
          fill="#EBEBEB"
          d="M271.19 355.47H322.18V357.22H271.19z"
          className="animable"
        ></path>
        <circle
          cx="329.74"
          cy="345.1"
          r="1.73"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="elw0xu2cclfej"
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          d="M337.18 345.1a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="el27amvremhq8"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 345.1a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="elor37eh3nza"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 345.1a1.73 1.73 0 11-1.73-1.74 1.74 1.74 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="elb7crdrarwlu"
          fill="#FFF"
          className="animable"
        ></path>
        <circle
          cx="352.58"
          cy="345.1"
          r="1.73"
          style={{
            WebkitTransformOrigin: 352.58,
            MsTransformOrigin: 352.58,
            transformOrigin: 352.58,
          }}
          id="el8bxb5v3gnny"
          fill="#FFF"
          className="animable"
        ></circle>
        <circle
          cx="329.74"
          cy="350.29"
          r="1.73"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="elrslsya0b2rc"
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          d="M337.18 350.29a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="elofv2zifd59r"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 350.29a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="eldprtyx0q0gb"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 350.29a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="el6cevurg6dx"
          fill="#FFF"
          className="animable"
        ></path>
        <circle
          cx="352.58"
          cy="350.29"
          r="1.73"
          style={{
            WebkitTransformOrigin: 352.58,
            MsTransformOrigin: 352.58,
            transformOrigin: 352.58,
          }}
          id="elsdf9y62klwt"
          fill="#FFF"
          className="animable"
        ></circle>
        <circle
          cx="329.74"
          cy="355.49"
          r="1.73"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="elavntu35805"
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          d="M337.18 355.49a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="elsfoeeeu4he"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 355.49a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="elthie3whe5jg"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 355.49a1.73 1.73 0 11-1.73-1.74 1.74 1.74 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="elwmnptlvk8jo"
          fill="#FFF"
          className="animable"
        ></path>
        <circle
          cx="352.58"
          cy="355.49"
          r="1.73"
          style={{
            WebkitTransformOrigin: 352.58,
            MsTransformOrigin: 352.58,
            transformOrigin: 352.58,
          }}
          id="eli5mzdwgdo2p"
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          style={{
            WebkitTransformOrigin: 325.23,
            MsTransformOrigin: 325.23,
            transformOrigin: 325.23,
          }}
          id="elfh405fiom8r"
          fill="#C7C7C7"
          d="M324.73 343.36H325.73V357.21000000000004H324.73z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 312.21,
            MsTransformOrigin: 312.21,
            transformOrigin: 312.21,
          }}
          id="el7y6qwa412tc"
          fill="#DBDBDB"
          d="M267.42 315.01H357V335.7H267.42z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elwc9u6w8mjbs"
          fill="#EBEBEB"
          d="M271.19 318.43H322.18V320.18H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elwpn0mpsnmt"
          fill="#EBEBEB"
          d="M271.19 321.46H322.18V323.21H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elqggi69m8gq"
          fill="#EBEBEB"
          d="M271.19 324.48H322.18V326.23H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="eln3ralc8livr"
          fill="#EBEBEB"
          d="M271.19 327.51H322.18V329.26H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elvrxkwwmi1cq"
          fill="#EBEBEB"
          d="M271.19 330.54H322.18V332.29H271.19z"
          className="animable"
        ></path>
        <path
          d="M331.47 320.16a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="elawadmj0yqz6"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M337.18 320.16a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="el45ph64rl80s"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 320.16a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="eltr1cva69z6n"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 320.16a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="el7vsz1cyr9k"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M354.31 320.16a1.74 1.74 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 352.57,
            MsTransformOrigin: 352.57,
            transformOrigin: 352.57,
          }}
          id="eltr3z46qxxo"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M331.47 325.36a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="el43po3xdfcew"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M337.18 325.36a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="elztfug5okewo"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 325.36a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="el1wwjpdpntr9"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 325.36a1.73 1.73 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="elbgx8ibbreva"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M354.31 325.36a1.74 1.74 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 352.57,
            MsTransformOrigin: 352.57,
            transformOrigin: 352.57,
          }}
          id="elipwn8kv6t8q"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M331.47 330.55a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="el9bdv5r0gnnh"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M337.18 330.55a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="elhiydfinalmc"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 330.55a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="eltyosj7xzct9"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 330.55a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="el7mtw935rltu"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M354.31 330.55a1.74 1.74 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 352.57,
            MsTransformOrigin: 352.57,
            transformOrigin: 352.57,
          }}
          id="el0ekshg8ior6"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 325.23,
            MsTransformOrigin: 325.23,
            transformOrigin: 325.23,
          }}
          id="elxesi4hh1ag"
          fill="#C7C7C7"
          d="M324.73 318.43H325.73V332.28000000000003H324.73z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 312.21,
            MsTransformOrigin: 312.21,
            transformOrigin: 312.21,
          }}
          id="ell6bteu1na3"
          fill="#DBDBDB"
          d="M267.42 290.08H357V310.77H267.42z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elu1rndy8wdwi"
          fill="#EBEBEB"
          d="M271.19 293.5H322.18V295.25H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="el1ieosc6h4ft"
          fill="#EBEBEB"
          d="M271.19 296.52H322.18V298.27H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="el54x5p8edrzq"
          fill="#EBEBEB"
          d="M271.19 299.55H322.18V301.3H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elqtr7dvzsxwq"
          fill="#EBEBEB"
          d="M271.19 302.58H322.18V304.33H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elt5o5lm2b9n"
          fill="#EBEBEB"
          d="M271.19 305.6H322.18V307.35H271.19z"
          className="animable"
        ></path>
        <path
          d="M331.47 295.23a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="elepbyrcoghff"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M337.18 295.23a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="eldnq0pxw5vni"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 295.23a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="elaro2pxtemfm"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 295.23a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="elgbrjf7yyy8w"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M354.31 295.23a1.74 1.74 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 352.57,
            MsTransformOrigin: 352.57,
            transformOrigin: 352.57,
          }}
          id="elzisfe9n3m7e"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M331.47 300.42a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="elezn64qnxe9i"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M337.18 300.42a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="el2wzovc7dwgg"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 300.42a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="elle2wffcgw5"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 300.42a1.73 1.73 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="eld8eaq7cqysh"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M354.31 300.42a1.74 1.74 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 352.57,
            MsTransformOrigin: 352.57,
            transformOrigin: 352.57,
          }}
          id="eld68kbtwjtrr"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M331.47 305.62a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="el645qn85qgun"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M337.18 305.62a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="elbaz8x8ep5fb"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 305.62a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="eltdeerl0t6h"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 305.62a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="el7mh4juv5srs"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M354.31 305.62a1.74 1.74 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 352.57,
            MsTransformOrigin: 352.57,
            transformOrigin: 352.57,
          }}
          id="elr975h5o6di"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 325.23,
            MsTransformOrigin: 325.23,
            transformOrigin: 325.23,
          }}
          id="eliyxcqorue7d"
          fill="#C7C7C7"
          d="M324.73 293.5H325.73V307.35H324.73z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 312.21,
            MsTransformOrigin: 312.21,
            transformOrigin: 312.21,
          }}
          id="el22o6t2z2yym"
          fill="#DBDBDB"
          d="M267.42 265.15H357V285.84H267.42z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="eldfekrwbokhw"
          fill="#EBEBEB"
          d="M271.19 268.56H322.18V270.31H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elafwloz5mrx"
          fill="#EBEBEB"
          d="M271.19 271.59H322.18V273.34H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="el08m3luz9n82r"
          fill="#EBEBEB"
          d="M271.19 274.62H322.18V276.37H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="el9hh6ycjvg2f"
          fill="#EBEBEB"
          d="M271.19 277.64H322.18V279.39H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elhlab54qzkau"
          fill="#EBEBEB"
          d="M271.19 280.67H322.18V282.42H271.19z"
          className="animable"
        ></path>
        <path
          d="M331.47 270.3a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="elwlndbr03ile"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M337.18 270.3a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="el8athpvqn1ui"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 270.3a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="elgm4jfj73tli"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 270.3a1.73 1.73 0 11-1.73-1.74 1.74 1.74 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="elyi6polo7tg8"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M354.31 270.3a1.74 1.74 0 11-1.73-1.74 1.74 1.74 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 352.57,
            MsTransformOrigin: 352.57,
            transformOrigin: 352.57,
          }}
          id="elsv35iwcmz2e"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M331.47 275.49a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="el0a3wmcyd01qi"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M337.18 275.49a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="elgg5p49lwkv"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 275.49a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="el078enx33iqyw"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 275.49a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="elbwc2c2qc3i"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M354.31 275.49a1.74 1.74 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 352.57,
            MsTransformOrigin: 352.57,
            transformOrigin: 352.57,
          }}
          id="elid24219hx1p"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M331.47 280.69a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="elcialpx4vzsh"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M337.18 280.69a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="elz8n4mww9iui"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 280.69a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="el2jdhpaywfz9"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 280.69a1.73 1.73 0 11-1.73-1.74 1.74 1.74 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="elskzkxgnigbh"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M354.31 280.69a1.74 1.74 0 11-1.73-1.74 1.74 1.74 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 352.57,
            MsTransformOrigin: 352.57,
            transformOrigin: 352.57,
          }}
          id="elxeyhfsxdv9b"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 325.23,
            MsTransformOrigin: 325.23,
            transformOrigin: 325.23,
          }}
          id="el9m4e7oljda"
          fill="#C7C7C7"
          d="M324.73 268.56H325.73V282.41H324.73z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 312.21,
            MsTransformOrigin: 312.21,
            transformOrigin: 312.21,
          }}
          id="elotupl8wp4mo"
          fill="#DBDBDB"
          d="M267.42 240.21H357V260.90000000000003H267.42z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elpxn1l684tw"
          fill="#EBEBEB"
          d="M271.19 243.63H322.18V245.38H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elmqjz8jjntr"
          fill="#EBEBEB"
          d="M271.19 246.66H322.18V248.41H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elbbpufhhkv5"
          fill="#EBEBEB"
          d="M271.19 249.68H322.18V251.43H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elcz4pcqeidp"
          fill="#EBEBEB"
          d="M271.19 252.71H322.18V254.46H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="el4p9kuuap3i2"
          fill="#EBEBEB"
          d="M271.19 255.74H322.18V257.49H271.19z"
          className="animable"
        ></path>
        <path
          d="M331.47 245.36a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="el87z7w8ry7z9"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M337.18 245.36a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="el5yj3toata7w"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 245.36a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="el8hi2sncolbb"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 245.36a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="elroiizy54u8"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M354.31 245.36a1.74 1.74 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 352.57,
            MsTransformOrigin: 352.57,
            transformOrigin: 352.57,
          }}
          id="el4nuiimwy2rm"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M331.47 250.56a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="el5sd1q97yusp"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M337.18 250.56a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="eler39l3lghbl"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 250.56a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="eldgtew70aga"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 250.56a1.73 1.73 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="elbfpnox5z6lk"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M354.31 250.56a1.74 1.74 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 352.57,
            MsTransformOrigin: 352.57,
            transformOrigin: 352.57,
          }}
          id="el0hbdq09ks6u"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M331.47 255.75a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="eli08ai15lbal"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M337.18 255.75a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="eltxibakiprk"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 255.75a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="el640ip8ldj3c"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 255.75a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="elgolw16lyv8o"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M354.31 255.75a1.74 1.74 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 352.57,
            MsTransformOrigin: 352.57,
            transformOrigin: 352.57,
          }}
          id="elx0oivebezj"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 325.23,
            MsTransformOrigin: 325.23,
            transformOrigin: 325.23,
          }}
          id="el7mqabaqwtnd"
          fill="#C7C7C7"
          d="M324.73 243.63H325.73V257.48H324.73z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 312.21,
            MsTransformOrigin: 312.21,
            transformOrigin: 312.21,
          }}
          id="elcjwmo2wp7zi"
          fill="#DBDBDB"
          d="M267.42 215.28H357V235.97H267.42z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elp32w8bq03xf"
          fill="#EBEBEB"
          d="M271.19 218.7H322.18V220.45H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="eld2dnwsbyibk"
          fill="#EBEBEB"
          d="M271.19 221.72H322.18V223.47H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elc50jqpmdjuo"
          fill="#EBEBEB"
          d="M271.19 224.75H322.18V226.5H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="el0okailkz6nlj"
          fill="#EBEBEB"
          d="M271.19 227.78H322.18V229.53H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elqrfkv15tz0b"
          fill="#EBEBEB"
          d="M271.19 230.81H322.18V232.56H271.19z"
          className="animable"
        ></path>
        <circle
          cx="329.74"
          cy="220.43"
          r="1.73"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="elzahyrw76vp"
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          d="M337.18 220.43a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="elt3jlxmcdiyq"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 220.43a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="eljblsxn7uxj"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 220.43a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="elog12q3uvrka"
          fill="#FFF"
          className="animable"
        ></path>
        <circle
          cx="352.58"
          cy="220.43"
          r="1.73"
          style={{
            WebkitTransformOrigin: 352.58,
            MsTransformOrigin: 352.58,
            transformOrigin: 352.58,
          }}
          id="elkpzbly33ili"
          fill="#FFF"
          className="animable"
        ></circle>
        <circle
          cx="329.74"
          cy="225.62"
          r="1.73"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="el8ll1j4lza2u"
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          d="M337.18 225.62a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="elf5o46bm37x7"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 225.62a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="el4ue6t34sxl2"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 225.62a1.73 1.73 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="el6thhbtlqq8i"
          fill="#FFF"
          className="animable"
        ></path>
        <circle
          cx="352.58"
          cy="225.62"
          r="1.73"
          style={{
            WebkitTransformOrigin: 352.58,
            MsTransformOrigin: 352.58,
            transformOrigin: 352.58,
          }}
          id="el36nhztc8u19"
          fill="#FFF"
          className="animable"
        ></circle>
        <circle
          cx="329.74"
          cy="230.82"
          r="1.73"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="elnv89vezain"
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          d="M337.18 230.82a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="elf7yxy65dljb"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 230.82a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="ellf3bef4s5kk"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 230.82a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="el30gmbf73xbt"
          fill="#FFF"
          className="animable"
        ></path>
        <circle
          cx="352.58"
          cy="230.82"
          r="1.73"
          style={{
            WebkitTransformOrigin: 352.58,
            MsTransformOrigin: 352.58,
            transformOrigin: 352.58,
          }}
          id="ely33cdjbnshn"
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          style={{
            WebkitTransformOrigin: 325.23,
            MsTransformOrigin: 325.23,
            transformOrigin: 325.23,
          }}
          id="elksrerz61u3g"
          fill="#C7C7C7"
          d="M324.73 218.7H325.73V232.54999999999998H324.73z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 312.21,
            MsTransformOrigin: 312.21,
            transformOrigin: 312.21,
          }}
          id="el79sjj8eg5tr"
          fill="#DBDBDB"
          d="M267.42 190.35H357V211.04H267.42z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elqjeg5r7h5r7"
          fill="#EBEBEB"
          d="M271.19 193.76H322.18V195.51H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elx9d9wlr6jwi"
          fill="#EBEBEB"
          d="M271.19 196.79H322.18V198.54H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="elbjmy5fdnv2b"
          fill="#EBEBEB"
          d="M271.19 199.82H322.18V201.57H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="eldu442w6tdow"
          fill="#EBEBEB"
          d="M271.19 202.85H322.18V204.6H271.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 296.685,
            MsTransformOrigin: 296.685,
            transformOrigin: 296.685,
          }}
          id="eljnoz03d1yg"
          fill="#EBEBEB"
          d="M271.19 205.87H322.18V207.62H271.19z"
          className="animable"
        ></path>
        <circle
          cx="329.74"
          cy="195.5"
          r="1.73"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="eloqu6m9yyikq"
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          d="M337.18 195.5a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="elgr9523ie1go"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 195.5a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="elku3l3o86i8"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 195.5a1.73 1.73 0 11-1.73-1.74 1.74 1.74 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="elylqly5lcsc8"
          fill="#FFF"
          className="animable"
        ></path>
        <circle
          cx="352.58"
          cy="195.5"
          r="1.73"
          style={{
            WebkitTransformOrigin: 352.58,
            MsTransformOrigin: 352.58,
            transformOrigin: 352.58,
          }}
          id="ely5atm7g1iab"
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          d="M331.47 200.69a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="elmlbndx3gk2j"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M337.18 200.69a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="el89xekkkq1wy"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 200.69a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="eli7ijem5p9t"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 200.69a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="elbxw5rvg95z"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M354.31 200.69a1.74 1.74 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 352.57,
            MsTransformOrigin: 352.57,
            transformOrigin: 352.57,
          }}
          id="elek8nfp60lqg"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M331.47 205.89a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 329.74,
            MsTransformOrigin: 329.74,
            transformOrigin: 329.74,
          }}
          id="eld8735m7akie"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M337.18 205.89a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 335.45,
            MsTransformOrigin: 335.45,
            transformOrigin: 335.45,
          }}
          id="elv8crojy2fo"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M342.89 205.89a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 341.16,
            MsTransformOrigin: 341.16,
            transformOrigin: 341.16,
          }}
          id="elgo825neopb9"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M348.6 205.89a1.73 1.73 0 11-1.73-1.74 1.74 1.74 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 346.87,
            MsTransformOrigin: 346.87,
            transformOrigin: 346.87,
          }}
          id="el5n7xjxa7p7r"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M354.31 205.89a1.74 1.74 0 11-1.73-1.74 1.74 1.74 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 352.57,
            MsTransformOrigin: 352.57,
            transformOrigin: 352.57,
          }}
          id="el03btqllmnkns"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 325.23,
            MsTransformOrigin: 325.23,
            transformOrigin: 325.23,
          }}
          id="elj6zod7jvp8g"
          fill="#C7C7C7"
          d="M324.73 193.76H325.73V207.60999999999999H324.73z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 283.34,
            MsTransformOrigin: 283.34,
            transformOrigin: 283.34,
          }}
          id="eld5qxnohxkxw"
          fill="#DBDBDB"
          d="M224.3 169.13H342.38V175.69H224.3z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 70.495,
            MsTransformOrigin: 70.495,
            transformOrigin: 70.495,
          }}
          id="elnm54rlip7t"
          fill="#C7C7C7"
          d="M42.28 151.69H98.71000000000001V392.48H42.28z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 150.64,
            MsTransformOrigin: 150.64,
            transformOrigin: 150.64,
          }}
          id="el2b922nzm2gn"
          fill="#EBEBEB"
          d="M98.71 151.69H202.57V392.48H98.71z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 151.29,
            MsTransformOrigin: 151.29,
            transformOrigin: 151.29,
          }}
          id="eli186u5pawvk"
          fill="#DBDBDB"
          d="M106.5 364.88H196.07999999999998V385.57H106.5z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elgqfc5vvyjy"
          fill="#EBEBEB"
          d="M110.27 368.3H161.26V370.05H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elpepmb889spd"
          fill="#EBEBEB"
          d="M110.27 371.32H161.26V373.07H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elo6ct3tv9tqe"
          fill="#EBEBEB"
          d="M110.27 374.35H161.26V376.1H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="el0oehw3kyvic9"
          fill="#EBEBEB"
          d="M110.27 377.38H161.26V379.13H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="el8m0lh2f3ukt"
          fill="#EBEBEB"
          d="M110.27 380.4H161.26V382.15H110.27z"
          className="animable"
        ></path>
        <path
          d="M170.56 370a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="elh5amd8iyu1a"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 370a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="ela9li9fcrz59"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 370a1.73 1.73 0 11-1.73-1.73A1.72 1.72 0 01182 370z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="eljnd1487dks"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 370a1.73 1.73 0 11-1.68-1.7 1.72 1.72 0 011.68 1.7z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elecxm58eihnf"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 370a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="elh33h7x1ccci"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M170.56 375.22a1.74 1.74 0 11-1.74-1.73 1.74 1.74 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="elzhersz7o3q"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 375.22a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="el6wbyc2k8k99"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 375.22a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="elvozy9j2dkbq"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 375.22a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elq3fthkjuoj"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 375.22a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="elxt68pidvdbp"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M170.56 380.42a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="elqgnmx0p827i"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 380.42a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="ela984b77yl2h"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 380.42a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="elh6vnqtyxxo6"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 380.42a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elpqxn141yc4"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 380.42a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="elf8czhatb6yi"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 164.31,
            MsTransformOrigin: 164.31,
            transformOrigin: 164.31,
          }}
          id="elltzmcpovtr"
          fill="#C7C7C7"
          d="M163.81 368.3H164.81V382.15000000000003H163.81z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 151.29,
            MsTransformOrigin: 151.29,
            transformOrigin: 151.29,
          }}
          id="elfo3dvdc9cd7"
          fill="#DBDBDB"
          d="M106.5 339.95H196.07999999999998V360.64H106.5z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="el92jpv5d1i0g"
          fill="#EBEBEB"
          d="M110.27 343.36H161.26V345.11H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="eljzi6nbabttn"
          fill="#EBEBEB"
          d="M110.27 346.39H161.26V348.14H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elhgkn55mdi9t"
          fill="#EBEBEB"
          d="M110.27 349.42H161.26V351.17H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="eltt05ykp9mu9"
          fill="#EBEBEB"
          d="M110.27 352.44H161.26V354.19H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="el599pdz1bdn8"
          fill="#EBEBEB"
          d="M110.27 355.47H161.26V357.22H110.27z"
          className="animable"
        ></path>
        <circle
          cx="168.82"
          cy="345.1"
          r="1.73"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="elrfxqxrvyovj"
          fill="#FFF"
          className="animable"
        ></circle>
        <circle
          cx="174.53"
          cy="345.1"
          r="1.73"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="elz5acxjkzwdf"
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          d="M182 345.1a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="els5uqd979zjh"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 345.1a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="el9xlolz5zfx9"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 345.1a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="el6a9zolbl21q"
          fill="#FFF"
          className="animable"
        ></path>
        <circle
          cx="168.82"
          cy="350.29"
          r="1.73"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="elfxfrfji5pff"
          fill="#FFF"
          className="animable"
        ></circle>
        <circle
          cx="174.53"
          cy="350.29"
          r="1.73"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="el8bpb5xj08rh"
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          d="M182 350.29a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="el6tmkqi2ypox"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 350.29a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elp8p80n62rad"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 350.29a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="eli7aiv0d9h8o"
          fill="#FFF"
          className="animable"
        ></path>
        <circle
          cx="168.82"
          cy="355.49"
          r="1.73"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="el8cpsz1u3obl"
          fill="#FFF"
          className="animable"
        ></circle>
        <circle
          cx="174.53"
          cy="355.49"
          r="1.73"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="ellkf0jduvjj9"
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          d="M182 355.49a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="elws02wgcvhda"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 355.49a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elec80e6q5cwr"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 355.49a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="elmufklxuevrk"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 164.31,
            MsTransformOrigin: 164.31,
            transformOrigin: 164.31,
          }}
          id="el639u3pfb5hn"
          fill="#C7C7C7"
          d="M163.81 343.36H164.81V357.21000000000004H163.81z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 151.29,
            MsTransformOrigin: 151.29,
            transformOrigin: 151.29,
          }}
          id="el3w84vxc8qhk"
          fill="#DBDBDB"
          d="M106.5 315.01H196.07999999999998V335.7H106.5z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elulhpv4rnknb"
          fill="#EBEBEB"
          d="M110.27 318.43H161.26V320.18H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elleez7jc67zr"
          fill="#EBEBEB"
          d="M110.27 321.46H161.26V323.21H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="el00dvm4s6cy6m"
          fill="#EBEBEB"
          d="M110.27 324.48H161.26V326.23H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="eled7a7hc08y"
          fill="#EBEBEB"
          d="M110.27 327.51H161.26V329.26H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="el340q8b1nizi"
          fill="#EBEBEB"
          d="M110.27 330.54H161.26V332.29H110.27z"
          className="animable"
        ></path>
        <path
          d="M170.56 320.16a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="ely067b47qh4"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 320.16a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="elj5pb8uti2k"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 320.16a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="el2v0autb6glf"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 320.16a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elrw5uvt83tf"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 320.16a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="el9exnjkwki9"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M170.56 325.36a1.74 1.74 0 11-1.74-1.73 1.74 1.74 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="elpqriinfu9"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 325.36a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="elx96j69og4c8"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 325.36a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="elpfao3o3l9ad"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 325.36a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="eltssgfqk62o"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 325.36a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="el9dfi9et3jp4"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M170.56 330.55a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="elasi9grcuvdr"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 330.55a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="elxbsxriwq3xk"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 330.55a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="elbo7bevc9c7t"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 330.55a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elox3abcq1df"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 330.55a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="elflppzf8vj3i"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 164.31,
            MsTransformOrigin: 164.31,
            transformOrigin: 164.31,
          }}
          id="elsbg5dhinu2m"
          fill="#C7C7C7"
          d="M163.81 318.43H164.81V332.28000000000003H163.81z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 151.29,
            MsTransformOrigin: 151.29,
            transformOrigin: 151.29,
          }}
          id="el5yr50t9ify5"
          fill="#DBDBDB"
          d="M106.5 290.08H196.07999999999998V310.77H106.5z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="eligoandsyfme"
          fill="#EBEBEB"
          d="M110.27 293.5H161.26V295.25H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elv91dskkppva"
          fill="#EBEBEB"
          d="M110.27 296.52H161.26V298.27H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elix1k9sywwz"
          fill="#EBEBEB"
          d="M110.27 299.55H161.26V301.3H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elpr8d5d66cz"
          fill="#EBEBEB"
          d="M110.27 302.58H161.26V304.33H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elvd42n5l1qnq"
          fill="#EBEBEB"
          d="M110.27 305.6H161.26V307.35H110.27z"
          className="animable"
        ></path>
        <path
          d="M170.56 295.23a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="el0xo63rrh068"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 295.23a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="el85vpcnml59b"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 295.23a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="el1e8topigdkb"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 295.23a1.73 1.73 0 11-1.68-1.73 1.72 1.72 0 011.68 1.73z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="eltl1o6nhvz7"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 295.23a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="elandspqhbz2i"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M170.56 300.42a1.74 1.74 0 11-1.74-1.73 1.74 1.74 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="eld9q69gy83qt"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 300.42a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="elc6hq7jm22j"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 300.42a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="elupgn1sw6kxb"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 300.42a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elzlpi75i5ec9"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 300.42a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="el4lcvbas69te"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M170.56 305.62a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="el565vij5acyb"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 305.62a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="el7k0gg43sww"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 305.62a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="el3uhsukmd1t5"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 305.62a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elrmth4yt10y9"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 305.62a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="elwcljddivcvr"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 164.31,
            MsTransformOrigin: 164.31,
            transformOrigin: 164.31,
          }}
          id="elrcypbozse2s"
          fill="#C7C7C7"
          d="M163.81 293.5H164.81V307.35H163.81z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 151.29,
            MsTransformOrigin: 151.29,
            transformOrigin: 151.29,
          }}
          id="eloj63nukbctl"
          fill="#DBDBDB"
          d="M106.5 265.15H196.07999999999998V285.84H106.5z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elt3788zrq1si"
          fill="#EBEBEB"
          d="M110.27 268.56H161.26V270.31H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elrly7ylxr45g"
          fill="#EBEBEB"
          d="M110.27 271.59H161.26V273.34H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elzktchouvmdr"
          fill="#EBEBEB"
          d="M110.27 274.62H161.26V276.37H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elb2er9dyk9oe"
          fill="#EBEBEB"
          d="M110.27 277.64H161.26V279.39H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elazev6n4l4as"
          fill="#EBEBEB"
          d="M110.27 280.67H161.26V282.42H110.27z"
          className="animable"
        ></path>
        <path
          d="M170.56 270.3a1.74 1.74 0 11-1.74-1.74 1.74 1.74 0 011.74 1.74z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="elue3du5irdm"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 270.3a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="el2rmixhhm2y"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 270.3a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="el0cpf4oku1f98"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 270.3a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="els5mat0ho4tl"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 270.3a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="elm4ib5bqbd1e"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M170.56 275.49a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="elgc5zyrrf4b"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 275.49a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="els6ol0ljuv8f"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 275.49a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="el4nedm5hwxsr"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 275.49a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elwh1zgbf0dh"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 275.49a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="el6u37pit5spt"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M170.56 280.69a1.74 1.74 0 11-1.74-1.74 1.74 1.74 0 011.74 1.74z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="el2q4ckvlvunu"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 280.69a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="el69w67gkat6e"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 280.69a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="elw17nnlw4dfb"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 280.69A1.73 1.73 0 11186 279a1.73 1.73 0 011.68 1.69z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="eluf3qk8sp37"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 280.69a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="elwrddaadkqhc"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 164.31,
            MsTransformOrigin: 164.31,
            transformOrigin: 164.31,
          }}
          id="elcnuallderwk"
          fill="#C7C7C7"
          d="M163.81 268.56H164.81V282.41H163.81z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 151.29,
            MsTransformOrigin: 151.29,
            transformOrigin: 151.29,
          }}
          id="elia7ydml7fk"
          fill="#DBDBDB"
          d="M106.5 240.21H196.07999999999998V260.90000000000003H106.5z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="ely08mjdwtaj"
          fill="#EBEBEB"
          d="M110.27 243.63H161.26V245.38H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elrgo1p9ubkvq"
          fill="#EBEBEB"
          d="M110.27 246.66H161.26V248.41H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="el7d3f3oe7qwr"
          fill="#EBEBEB"
          d="M110.27 249.68H161.26V251.43H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elf2hswgmgox"
          fill="#EBEBEB"
          d="M110.27 252.71H161.26V254.46H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elkssahbwxlpq"
          fill="#EBEBEB"
          d="M110.27 255.74H161.26V257.49H110.27z"
          className="animable"
        ></path>
        <path
          d="M170.56 245.36a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="el5ouy7n78r64"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 245.36a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="elx1g949q0fgg"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 245.36a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="elx4m43ywfnqp"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 245.36a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elr61a67t9i3"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 245.36a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="els7315jqgp2"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M170.56 250.56a1.74 1.74 0 11-1.74-1.73 1.74 1.74 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="el591kkcxohn7"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 250.56a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="elz27z1h5pse"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 250.56a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="elz6llgdihp3a"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 250.56a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elt34kkqg2hbd"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 250.56a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="el1xy0hglcper"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M170.56 255.75a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="elfgikt8bmseg"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 255.75a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="el98ih9qfvj49"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 255.75a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="elgoj8w0tabs"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 255.75A1.73 1.73 0 11186 254a1.72 1.72 0 011.68 1.75z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elxkl471274hs"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 255.75a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="elqdi3xyoazp"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 164.31,
            MsTransformOrigin: 164.31,
            transformOrigin: 164.31,
          }}
          id="el6lyi4jdva8s"
          fill="#C7C7C7"
          d="M163.81 243.63H164.81V257.48H163.81z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 151.29,
            MsTransformOrigin: 151.29,
            transformOrigin: 151.29,
          }}
          id="elj2usesdi7nk"
          fill="#DBDBDB"
          d="M106.5 215.28H196.07999999999998V235.97H106.5z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elojm106zos7"
          fill="#EBEBEB"
          d="M110.27 218.7H161.26V220.45H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elekabtr7g8ak"
          fill="#EBEBEB"
          d="M110.27 221.72H161.26V223.47H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="ela8mnjcb47gf"
          fill="#EBEBEB"
          d="M110.27 224.75H161.26V226.5H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="eluh2u0w6p3e"
          fill="#EBEBEB"
          d="M110.27 227.78H161.26V229.53H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elyhb6c5wt8wb"
          fill="#EBEBEB"
          d="M110.27 230.81H161.26V232.56H110.27z"
          className="animable"
        ></path>
        <circle
          cx="168.82"
          cy="220.43"
          r="1.73"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="el7c6uztf4zxb"
          fill="#FFF"
          className="animable"
        ></circle>
        <circle
          cx="174.53"
          cy="220.43"
          r="1.73"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="eld0buhr0fm0o"
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          d="M182 220.43a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="el48e691915x6"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 220.43a1.73 1.73 0 11-1.68-1.73 1.72 1.72 0 011.68 1.73z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elfedn6s2mt8u"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 220.43a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="elaprlc2uaf0j"
          fill="#FFF"
          className="animable"
        ></path>
        <circle
          cx="168.82"
          cy="225.62"
          r="1.73"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="elq1xpxewvis"
          fill="#FFF"
          className="animable"
        ></circle>
        <circle
          cx="174.53"
          cy="225.62"
          r="1.73"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="eltaavbyi5h1m"
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          d="M182 225.62a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="elggqng3o3p4k"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 225.62a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elggx9985ql4j"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 225.62a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="el3gpvivem8oj"
          fill="#FFF"
          className="animable"
        ></path>
        <circle
          cx="168.82"
          cy="230.82"
          r="1.73"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="eluzxjbstv31"
          fill="#FFF"
          className="animable"
        ></circle>
        <circle
          cx="174.53"
          cy="230.82"
          r="1.73"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="elx8xn83mhx7e"
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          d="M182 230.82a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="elp1321jo378d"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 230.82a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elcg6mizejp9g"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 230.82a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="el486i8nchjqc"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 164.31,
            MsTransformOrigin: 164.31,
            transformOrigin: 164.31,
          }}
          id="elc0zpbxayb0u"
          fill="#C7C7C7"
          d="M163.81 218.7H164.81V232.54999999999998H163.81z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 151.29,
            MsTransformOrigin: 151.29,
            transformOrigin: 151.29,
          }}
          id="elqscej0xjhn"
          fill="#DBDBDB"
          d="M106.5 190.35H196.07999999999998V211.04H106.5z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elzs2th7dy63c"
          fill="#EBEBEB"
          d="M110.27 193.76H161.26V195.51H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elcdovhxdlif9"
          fill="#EBEBEB"
          d="M110.27 196.79H161.26V198.54H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="ellc2bqo1rv2"
          fill="#EBEBEB"
          d="M110.27 199.82H161.26V201.57H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elpty0f4xlqse"
          fill="#EBEBEB"
          d="M110.27 202.85H161.26V204.6H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="el5hj1jerp8ma"
          fill="#EBEBEB"
          d="M110.27 205.87H161.26V207.62H110.27z"
          className="animable"
        ></path>
        <circle
          cx="168.82"
          cy="195.5"
          r="1.73"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="elkrxsooqeb0j"
          fill="#FFF"
          className="animable"
        ></circle>
        <circle
          cx="174.53"
          cy="195.5"
          r="1.73"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="elo24i9iv8x3r"
          fill="#FFF"
          className="animable"
        ></circle>
        <path
          d="M182 195.5a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="elijkxrp7je6j"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 195.5a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elk2pbbptmt7a"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 195.5a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="elh2l41s49bgb"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M170.56 200.69a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="elhrdgwd8l6ft"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 200.69a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="el0gaxfn8bi8uv"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 200.69a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="elg7gnh3g79xg"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 200.69A1.73 1.73 0 11186 199a1.72 1.72 0 011.68 1.69z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elq1q11xhs1e9"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 200.69a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="elt5uq7dc5exh"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M170.56 205.89a1.74 1.74 0 11-1.74-1.74 1.74 1.74 0 011.74 1.74z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="el5hontpprxtj"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 205.89a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="elcpybxy51ny"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 205.89a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="elmphfwu75vy"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 205.89a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="el8dosc4yeq7x"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 205.89a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="el2ujj00uqrug"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 164.31,
            MsTransformOrigin: 164.31,
            transformOrigin: 164.31,
          }}
          id="el7t9rymbstf6"
          fill="#C7C7C7"
          d="M163.81 193.76H164.81V207.60999999999999H163.81z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 151.29,
            MsTransformOrigin: 151.29,
            transformOrigin: 151.29,
          }}
          id="el6aaklb7d6o2"
          fill="#DBDBDB"
          d="M106.5 165.41H196.07999999999998V186.1H106.5z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="el933n7dcx6xj"
          fill="#EBEBEB"
          d="M110.27 168.83H161.26V170.58H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="el7drwrdayppq"
          fill="#EBEBEB"
          d="M110.27 171.86H161.26V173.61H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="eli6m99ks7rz"
          fill="#EBEBEB"
          d="M110.27 174.89H161.26V176.64H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elcz1z389sqf"
          fill="#EBEBEB"
          d="M110.27 177.91H161.26V179.66H110.27z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 135.765,
            MsTransformOrigin: 135.765,
            transformOrigin: 135.765,
          }}
          id="elrf4cq71ldh"
          fill="#EBEBEB"
          d="M110.27 180.94H161.26V182.69H110.27z"
          className="animable"
        ></path>
        <path
          d="M170.56 170.56a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="els9mek0ls5fc"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 170.56a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="el79m5us2pujd"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 170.56a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="ellsy6nqjqrmd"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 170.56a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elbr2wmigw1e5"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 170.56a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="elbwemc2igr2"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M170.56 175.76a1.74 1.74 0 11-1.74-1.73 1.74 1.74 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="el8pc3np9een"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 175.76a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="elsuop7e66pj"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 175.76a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="el2f7sv3bhli3"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 175.76A1.73 1.73 0 11186 174a1.73 1.73 0 011.68 1.76z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elsqnv7izzfc8"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 175.76a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="el1x5ig2flj3k"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M170.56 181a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 168.82,
            MsTransformOrigin: 168.82,
            transformOrigin: 168.82,
          }}
          id="elcvvc68mejr8"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M176.26 181a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 174.53,
            MsTransformOrigin: 174.53,
            transformOrigin: 174.53,
          }}
          id="elh1s5f3jk9cj"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M182 181a1.73 1.73 0 11-1.73-1.73A1.72 1.72 0 01182 181z"
          style={{
            WebkitTransformOrigin: 180.27,
            MsTransformOrigin: 180.27,
            transformOrigin: 180.27,
          }}
          id="el31190ss3e9h"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M187.68 181a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 185.95,
            MsTransformOrigin: 185.95,
            transformOrigin: 185.95,
          }}
          id="elzi2xir7jn0a"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M193.39 181a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 191.66,
            MsTransformOrigin: 191.66,
            transformOrigin: 191.66,
          }}
          id="el55mlwc05is7"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 164.31,
            MsTransformOrigin: 164.31,
            transformOrigin: 164.31,
          }}
          id="elpv39hl4o7di"
          fill="#C7C7C7"
          d="M163.81 168.83H164.81V182.68H163.81z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 122.42,
            MsTransformOrigin: 122.42,
            transformOrigin: 122.42,
          }}
          id="el1ju1xmvg4wf"
          fill="#DBDBDB"
          d="M63.38 145.13H181.46V151.69H63.38z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 404.725,
            MsTransformOrigin: 404.725,
            transformOrigin: 404.725,
          }}
          id="elzlonbqsxmzq"
          fill="#EBEBEB"
          d="M418.59 392.43L417.59 392.43 417.59 266.93 390.86 230.44 390.86 161.94 391.86 161.94 391.86 230.12 418.59 266.6 418.59 392.43z"
          className="animable"
        ></path>
        <path
          d="M391.36 162.49a2.88 2.88 0 112.88-2.88 2.88 2.88 0 01-2.88 2.88zm0-4.75a1.88 1.88 0 101.88 1.87 1.87 1.87 0 00-1.88-1.87z"
          style={{
            WebkitTransformOrigin: 391.36,
            MsTransformOrigin: 391.36,
            transformOrigin: 391.36,
          }}
          id="elcuuahf1dovd"
          fill="#EBEBEB"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 397.845,
            MsTransformOrigin: 397.845,
            transformOrigin: 397.845,
          }}
          id="elz56i0wjcqto"
          fill="#EBEBEB"
          d="M411.71 392.43L410.71 392.43 410.71 271.33 383.98 234.85 383.98 186.94 384.98 186.94 384.98 234.53 411.71 271.01 411.71 392.43z"
          className="animable"
        ></path>
        <path
          d="M384.48 187.48a2.88 2.88 0 112.87-2.87 2.88 2.88 0 01-2.87 2.87zm0-4.75a1.88 1.88 0 101.87 1.88 1.88 1.88 0 00-1.87-1.88z"
          style={{
            WebkitTransformOrigin: 384.47,
            MsTransformOrigin: 384.47,
            transformOrigin: 384.47,
          }}
          id="elf247l2gkyjo"
          fill="#EBEBEB"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 424.72,
            MsTransformOrigin: 424.72,
            transformOrigin: 424.72,
          }}
          id="elg9my0ococa"
          fill="#EBEBEB"
          d="M424.22 226.02H425.22V392.43H424.22z"
          className="animable"
        ></path>
        <path
          d="M424.72 226.52a2.88 2.88 0 112.88-2.88 2.88 2.88 0 01-2.88 2.88zm0-4.75a1.88 1.88 0 101.88 1.87 1.87 1.87 0 00-1.88-1.87z"
          style={{
            WebkitTransformOrigin: 424.72,
            MsTransformOrigin: 424.72,
            transformOrigin: 424.72,
          }}
          id="elhnx10mu4f7c"
          fill="#EBEBEB"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 440.185,
            MsTransformOrigin: 440.185,
            transformOrigin: 440.185,
          }}
          id="elakz9cc5c1xt"
          fill="#EBEBEB"
          d="M431.61 392.43L430.61 392.43 430.61 307.73 448.76 273.5 448.76 212.26 449.76 212.26 449.76 273.75 431.61 307.98 431.61 392.43z"
          className="animable"
        ></path>
        <path
          d="M449.26 212.76a2.88 2.88 0 112.87-2.88 2.88 2.88 0 01-2.87 2.88zm0-4.75a1.88 1.88 0 101.87 1.87 1.88 1.88 0 00-1.87-1.88z"
          style={{
            WebkitTransformOrigin: 449.25,
            MsTransformOrigin: 449.25,
            transformOrigin: 449.25,
          }}
          id="el9nu7qhtg5gd"
          fill="#EBEBEB"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 448.155,
            MsTransformOrigin: 448.155,
            transformOrigin: 448.155,
          }}
          id="elrghbun643v"
          fill="#EBEBEB"
          d="M437.96 392.43L436.96 392.43 436.96 311.38 458.35 273.54 458.35 233.25 459.35 233.25 459.35 273.8 437.96 311.64 437.96 392.43z"
          className="animable"
        ></path>
        <path
          d="M458.85 233.75a2.88 2.88 0 112.88-2.87 2.88 2.88 0 01-2.88 2.87zm0-4.75a1.88 1.88 0 101.88 1.88 1.88 1.88 0 00-1.88-1.88z"
          style={{
            WebkitTransformOrigin: 458.85,
            MsTransformOrigin: 458.85,
            transformOrigin: 458.85,
          }}
          id="el01hnhfyaeegv"
          fill="#EBEBEB"
          className="animable"
        ></path>
      </g>
      <g
        id="freepik--Shadow--inject-32"
        className="animable"
        style={{
          WebkitTransformOrigin: 250,
          MsTransformOrigin: 250,
          transformOrigin: 250,
        }}
      >
        <ellipse
          cx="250"
          cy="431.23"
          fill="#EBEBEB"
          rx="211.65"
          ry="23.07"
          style={{
            WebkitTransformOrigin: 250,
            MsTransformOrigin: 250,
            transformOrigin: 250,
          }}
          id="el6ey1ysshcos"
          className="animable"
        ></ellipse>
      </g>
      <g
        id="freepik--Server--inject-32"
        className="animable"
        style={{
          WebkitTransformOrigin: 216.44,
          MsTransformOrigin: 216.44,
          transformOrigin: 216.44,
        }}
      >
        <path
          style={{
            WebkitTransformOrigin: 157.755,
            MsTransformOrigin: 157.755,
            transformOrigin: 157.755,
          }}
          id="els1rvlkk50p"
          fill="#263238"
          d="M129.54 179.69H185.97V392.48H129.54z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 237.91,
            MsTransformOrigin: 237.91,
            transformOrigin: 237.91,
          }}
          id="elthkgrrg7sb"
          fill="#455A64"
          d="M185.98 179.69H289.84V392.48H185.98z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 238.55,
            MsTransformOrigin: 238.55,
            transformOrigin: 238.55,
          }}
          id="el4mzlxny70jq"
          fill="#37474F"
          d="M193.76 364.88H283.34V385.57H193.76z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="elby4x2ltxjwu"
          fill="#455A64"
          d="M197.53 368.3H248.52V370.05H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="el3lj8fgq7nh6"
          fill="#455A64"
          d="M197.53 371.32H248.52V373.07H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="elep9ggugnvb"
          fill="#455A64"
          d="M197.53 374.35H248.52V376.1H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="ely2judy0mdad"
          fill="#455A64"
          d="M197.53 377.38H248.52V379.13H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="elc6ktfwth0u"
          fill="#455A64"
          d="M197.53 380.4H248.52V382.15H197.53z"
          className="animable"
        ></path>
        <path
          d="M257.82 370a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="ell60rqdnqs5"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M263.53 370a1.74 1.74 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 261.79,
            MsTransformOrigin: 261.79,
            transformOrigin: 261.79,
          }}
          id="el7y3izvkto4n"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M269.24 370a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="el1m1iyz2dklu"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M274.94 370a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="eli3gs7fzf63g"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 370a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="ellhbh73bgl3b"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M257.82 375.22a1.73 1.73 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="elpo3qq4f8v3"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M263.53 375.22a1.74 1.74 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 261.79,
            MsTransformOrigin: 261.79,
            transformOrigin: 261.79,
          }}
          id="el9g2xlbifnlk"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M269.24 375.22a1.74 1.74 0 11-1.74-1.73 1.74 1.74 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="elz82ddoviyz"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M274.94 375.22a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="elkvupfv27nhl"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 375.22a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="elw3jrt2iz38s"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M257.82 380.42a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="el2ct6ufnslys"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M263.53 380.42a1.74 1.74 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 261.79,
            MsTransformOrigin: 261.79,
            transformOrigin: 261.79,
          }}
          id="elmiqy5rt8jhh"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M269.24 380.42a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="el26170gtfqqei"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M274.94 380.42a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="elavbvztn2ds5"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 380.42a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="el98svgvv15y"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 251.57,
            MsTransformOrigin: 251.57,
            transformOrigin: 251.57,
          }}
          id="el1wgq2srdaf9"
          fill="#263238"
          d="M251.07 368.3H252.07V382.15000000000003H251.07z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 238.55,
            MsTransformOrigin: 238.55,
            transformOrigin: 238.55,
          }}
          id="elxhc5swy6jqc"
          fill="#37474F"
          d="M193.76 339.95H283.34V360.64H193.76z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="el04mwr6akav9"
          fill="#455A64"
          d="M197.53 343.36H248.52V345.11H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="elqr00wpic8xj"
          fill="#455A64"
          d="M197.53 346.39H248.52V348.14H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="el95b8yr0l62o"
          fill="#455A64"
          d="M197.53 349.42H248.52V351.17H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="elefqvg4vv4n6"
          fill="#455A64"
          d="M197.53 352.44H248.52V354.19H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="elmuqyc7kjqd"
          fill="#455A64"
          d="M197.53 355.47H248.52V357.22H197.53z"
          className="animable"
        ></path>
        <path
          d="M257.82 345.1a1.73 1.73 0 11-1.73-1.74 1.74 1.74 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="el7373tkw8mt7"
          fill="#000A18"
          className="animable"
        ></path>
        <circle
          cx="261.8"
          cy="345.1"
          r="1.73"
          style={{
            WebkitTransformOrigin: 261.8,
            MsTransformOrigin: 261.8,
            transformOrigin: 261.8,
          }}
          id="el3w4aiwgy6z2"
          fill="#000A18"
          className="animable"
        ></circle>
        <circle
          cx="267.5"
          cy="345.1"
          r="1.73"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="elazb5pt43gd"
          fill="#000A18"
          className="animable"
        ></circle>
        <path
          d="M274.94 345.1a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="elb2cjwcsa01c"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 345.1a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="elr67y8sqefcq"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M257.82 350.29a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="eldqwr7k7h2n"
          fill="#000A18"
          className="animable"
        ></path>
        <circle
          cx="261.8"
          cy="350.29"
          r="1.73"
          style={{
            WebkitTransformOrigin: 261.8,
            MsTransformOrigin: 261.8,
            transformOrigin: 261.8,
          }}
          id="elaq916fs7reg"
          fill="#000A18"
          className="animable"
        ></circle>
        <circle
          cx="267.5"
          cy="350.29"
          r="1.73"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="elfeblx3v3z9"
          fill="#000A18"
          className="animable"
        ></circle>
        <path
          d="M274.94 350.29a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="elynfxe1sqrpn"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 350.29a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="el9lovhb426ye"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M257.82 355.49a1.73 1.73 0 11-1.73-1.74 1.74 1.74 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="elf3w9zyjyrdt"
          fill="#000A18"
          className="animable"
        ></path>
        <circle
          cx="261.8"
          cy="355.49"
          r="1.73"
          style={{
            WebkitTransformOrigin: 261.8,
            MsTransformOrigin: 261.8,
            transformOrigin: 261.8,
          }}
          id="eluy12lk7zzqg"
          fill="#000A18"
          className="animable"
        ></circle>
        <circle
          cx="267.5"
          cy="355.49"
          r="1.73"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="el0snn106vfp2l"
          fill="#000A18"
          className="animable"
        ></circle>
        <path
          d="M274.94 355.49a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="el1x3k63lrume"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 355.49a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="el46dv8m5n6qg"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 251.57,
            MsTransformOrigin: 251.57,
            transformOrigin: 251.57,
          }}
          id="elbkhp8zgggbg"
          fill="#263238"
          d="M251.07 343.36H252.07V357.21000000000004H251.07z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 238.55,
            MsTransformOrigin: 238.55,
            transformOrigin: 238.55,
          }}
          id="eln0toi134eol"
          fill="#37474F"
          d="M193.76 315.01H283.34V335.7H193.76z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="eltnij1l28x4"
          fill="#455A64"
          d="M197.53 318.43H248.52V320.18H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="el41pa9gt2w0d"
          fill="#455A64"
          d="M197.53 321.46H248.52V323.21H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="el6dnd9ftahmr"
          fill="#455A64"
          d="M197.53 324.48H248.52V326.23H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="eljkleo6re1n"
          fill="#455A64"
          d="M197.53 327.51H248.52V329.26H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="elsgd7tx1rmcn"
          fill="#455A64"
          d="M197.53 330.54H248.52V332.29H197.53z"
          className="animable"
        ></path>
        <path
          d="M257.82 320.16a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="el3rtp7l9srw4"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M263.53 320.16a1.74 1.74 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 261.79,
            MsTransformOrigin: 261.79,
            transformOrigin: 261.79,
          }}
          id="eleovi7sdqbhs"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M269.24 320.16a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="elpdq4696jtq"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M274.94 320.16a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="el8t71txatx8f"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 320.16a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="eljivi0g2f7ye"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M257.82 325.36a1.73 1.73 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="el1vmp02il3j2"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M263.53 325.36a1.74 1.74 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 261.79,
            MsTransformOrigin: 261.79,
            transformOrigin: 261.79,
          }}
          id="el8z52ad3zc9e"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M269.24 325.36a1.74 1.74 0 11-1.74-1.73 1.74 1.74 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="elr1m7jx1a7n"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M274.94 325.36a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="el7mgrcnr3ye8"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 325.36a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="el5brzahrc54a"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M257.82 330.55a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="ele0lbv53g2k"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M263.53 330.55a1.74 1.74 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 261.79,
            MsTransformOrigin: 261.79,
            transformOrigin: 261.79,
          }}
          id="el9zbiffb428s"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M269.24 330.55a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="el162p4y1vkkz"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M274.94 330.55a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="elrzh45vaehof"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 330.55a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="elwq3malbnyi"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 251.57,
            MsTransformOrigin: 251.57,
            transformOrigin: 251.57,
          }}
          id="elqpggax6hnj"
          fill="#263238"
          d="M251.07 318.43H252.07V332.28000000000003H251.07z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 238.55,
            MsTransformOrigin: 238.55,
            transformOrigin: 238.55,
          }}
          id="elqtnvbkj4p0m"
          fill="#37474F"
          d="M193.76 290.08H283.34V310.77H193.76z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="elgx880t914b"
          fill="#455A64"
          d="M197.53 293.5H248.52V295.25H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="el4m7ebs0e084"
          fill="#455A64"
          d="M197.53 296.52H248.52V298.27H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="el1axwa2iix5lh"
          fill="#455A64"
          d="M197.53 299.55H248.52V301.3H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="eldib7qw8uvzt"
          fill="#455A64"
          d="M197.53 302.58H248.52V304.33H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="elrqmoreqnsz"
          fill="#455A64"
          d="M197.53 305.6H248.52V307.35H197.53z"
          className="animable"
        ></path>
        <path
          d="M257.82 295.23a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="elproqfvgigfk"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M263.53 295.23a1.74 1.74 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 261.79,
            MsTransformOrigin: 261.79,
            transformOrigin: 261.79,
          }}
          id="elih7a4svjt5"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M269.24 295.23a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="elw6gois623dn"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M274.94 295.23a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="elfuu07zix1qh"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 295.23a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="el80t5hvqj7ba"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M257.82 300.42a1.73 1.73 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="eloryr7fn1bxn"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M263.53 300.42a1.74 1.74 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 261.79,
            MsTransformOrigin: 261.79,
            transformOrigin: 261.79,
          }}
          id="elpdqohlzwu9r"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M269.24 300.42a1.74 1.74 0 11-1.74-1.73 1.74 1.74 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="el3vo7zl9muml"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M274.94 300.42a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="el7o4vye3dxd"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 300.42a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="el18tp5g9f9rz"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M257.82 305.62a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="elk78zs3v6lng"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M263.53 305.62a1.74 1.74 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 261.79,
            MsTransformOrigin: 261.79,
            transformOrigin: 261.79,
          }}
          id="elyzbyp9atxal"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M269.24 305.62a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="elbeevqquurs"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M274.94 305.62a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="elljnwujucc"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 305.62a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="elkcu9vtimg5"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 251.57,
            MsTransformOrigin: 251.57,
            transformOrigin: 251.57,
          }}
          id="el7wqcn12lce6"
          fill="#263238"
          d="M251.07 293.5H252.07V307.35H251.07z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 238.55,
            MsTransformOrigin: 238.55,
            transformOrigin: 238.55,
          }}
          id="el31imms0nazd"
          fill="#37474F"
          d="M193.76 265.15H283.34V285.84H193.76z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="el9psd6cwm3pd"
          fill="#455A64"
          d="M197.53 268.56H248.52V270.31H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="elmcpjmlxinc"
          fill="#455A64"
          d="M197.53 271.59H248.52V273.34H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="el7g1zlzl2emc"
          fill="#455A64"
          d="M197.53 274.62H248.52V276.37H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="eltqqk0tadtl"
          fill="#455A64"
          d="M197.53 277.64H248.52V279.39H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="ellughvvf81i"
          fill="#455A64"
          d="M197.53 280.67H248.52V282.42H197.53z"
          className="animable"
        ></path>
        <path
          d="M257.82 270.3a1.73 1.73 0 11-1.73-1.74 1.74 1.74 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="el2b81ioyu7o4"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M263.53 270.3a1.74 1.74 0 11-1.73-1.74 1.74 1.74 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 261.79,
            MsTransformOrigin: 261.79,
            transformOrigin: 261.79,
          }}
          id="elvpyzjarh6b9"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M269.24 270.3a1.74 1.74 0 11-1.74-1.74 1.74 1.74 0 011.74 1.74z"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="el1sjpy61xo8g"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M274.94 270.3a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="el1o9qh93g4hf"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 270.3a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="eleh0rv9cyv58"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M257.82 275.49a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="eldq881crg3z7"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M263.53 275.49a1.74 1.74 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 261.79,
            MsTransformOrigin: 261.79,
            transformOrigin: 261.79,
          }}
          id="elpxrqo26wl1"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M269.24 275.49a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="eluo6tmm3ej28"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M274.94 275.49a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="elai75gehuj6g"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 275.49a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="el6dnv94bvnpx"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M257.82 280.69a1.73 1.73 0 11-1.73-1.74 1.74 1.74 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="el64csrchxvrf"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M263.53 280.69a1.74 1.74 0 11-1.73-1.69 1.74 1.74 0 011.73 1.69z"
          style={{
            WebkitTransformOrigin: 261.791,
            MsTransformOrigin: 261.791,
            transformOrigin: 261.791,
          }}
          id="ely8pf2n3m3w"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M269.24 280.69a1.74 1.74 0 11-1.74-1.69 1.74 1.74 0 011.74 1.69z"
          style={{
            WebkitTransformOrigin: 267.501,
            MsTransformOrigin: 267.501,
            transformOrigin: 267.501,
          }}
          id="el3q4b75f5ogo"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M274.94 280.69a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="el0b4efw50cq7u"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 280.69a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="eligu1j15tbop"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 251.57,
            MsTransformOrigin: 251.57,
            transformOrigin: 251.57,
          }}
          id="el2pd3fm37ywe"
          fill="#263238"
          d="M251.07 268.56H252.07V282.41H251.07z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 238.55,
            MsTransformOrigin: 238.55,
            transformOrigin: 238.55,
          }}
          id="elgtib9qiuurs"
          fill="#37474F"
          d="M193.76 240.21H283.34V260.90000000000003H193.76z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="eldorf36hn87r"
          fill="#455A64"
          d="M197.53 243.63H248.52V245.38H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="elafclbybnw1a"
          fill="#455A64"
          d="M197.53 246.66H248.52V248.41H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="elldsyzhhy3f"
          fill="#455A64"
          d="M197.53 249.68H248.52V251.43H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="elkpedtm0oqbb"
          fill="#455A64"
          d="M197.53 252.71H248.52V254.46H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="elndgubz2sdan"
          fill="#455A64"
          d="M197.53 255.74H248.52V257.49H197.53z"
          className="animable"
        ></path>
        <path
          d="M257.82 245.36a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="ellfz4cqz5gys"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M263.53 245.36a1.74 1.74 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 261.79,
            MsTransformOrigin: 261.79,
            transformOrigin: 261.79,
          }}
          id="eln6zjn8obso"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M269.24 245.36a1.74 1.74 0 11-1.74-1.73 1.73 1.73 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="el8ht90k7r1gn"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M274.94 245.36a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="elydtfmy9zjil"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 245.36a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="el8sxiuyfl7r4"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M257.82 250.56a1.73 1.73 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="eluxkfqwted3"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M263.53 250.56a1.74 1.74 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 261.79,
            MsTransformOrigin: 261.79,
            transformOrigin: 261.79,
          }}
          id="elk5r2c25om4"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M269.24 250.56a1.74 1.74 0 11-1.74-1.73 1.74 1.74 0 011.74 1.73z"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="elee5d16jzk2l"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M274.94 250.56a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="el4kb1j1v1l3f"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 250.56a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="elyjxu8ql632h"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M257.82 255.75a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="el05q3qgdqf4u"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M263.53 255.75a1.74 1.74 0 11-1.73-1.75 1.73 1.73 0 011.73 1.75z"
          style={{
            WebkitTransformOrigin: 261.79,
            MsTransformOrigin: 261.79,
            transformOrigin: 261.79,
          }}
          id="el31j9vxhsdjo"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M269.24 255.75a1.74 1.74 0 11-1.74-1.75 1.73 1.73 0 011.74 1.75z"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="el2otnc336nbt"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M274.94 255.75a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="el90qvqvpvb2p"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 255.75a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="elzn2dtwhuf6k"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 251.57,
            MsTransformOrigin: 251.57,
            transformOrigin: 251.57,
          }}
          id="elud3bhjjdzrj"
          fill="#263238"
          d="M251.07 243.63H252.07V257.48H251.07z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 258.55,
            MsTransformOrigin: 258.55,
            transformOrigin: 258.55,
          }}
          id="elkug7awv2g7k"
          fill="#37474F"
          d="M213.76 215.28H303.34V235.97H213.76z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 243.025,
            MsTransformOrigin: 243.025,
            transformOrigin: 243.025,
          }}
          id="elbcvwhu3p3hp"
          fill="#455A64"
          d="M217.53 218.7H268.52V220.45H217.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 243.025,
            MsTransformOrigin: 243.025,
            transformOrigin: 243.025,
          }}
          id="el7qhoj703qs9"
          fill="#455A64"
          d="M217.53 221.72H268.52V223.47H217.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 243.025,
            MsTransformOrigin: 243.025,
            transformOrigin: 243.025,
          }}
          id="elnadwpmums2"
          fill="#455A64"
          d="M217.53 224.75H268.52V226.5H217.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 243.025,
            MsTransformOrigin: 243.025,
            transformOrigin: 243.025,
          }}
          id="el768nsxsqz4"
          fill="#455A64"
          d="M217.53 227.78H268.52V229.53H217.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 243.025,
            MsTransformOrigin: 243.025,
            transformOrigin: 243.025,
          }}
          id="elt4nxbzhuwx9"
          fill="#455A64"
          d="M217.53 230.81H268.52V232.56H217.53z"
          className="animable"
        ></path>
        <path
          d="M277.82 220.43a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 276.09,
            MsTransformOrigin: 276.09,
            transformOrigin: 276.09,
          }}
          id="el9ja54ufqgkn"
          fill="#000A18"
          className="animable"
        ></path>
        <circle
          cx="281.8"
          cy="220.43"
          r="1.73"
          style={{
            WebkitTransformOrigin: 281.8,
            MsTransformOrigin: 281.8,
            transformOrigin: 281.8,
          }}
          id="elx5e9p9wafkp"
          fill="#000A18"
          className="animable"
        ></circle>
        <circle
          cx="287.5"
          cy="220.43"
          r="1.73"
          style={{
            WebkitTransformOrigin: 287.5,
            MsTransformOrigin: 287.5,
            transformOrigin: 287.5,
          }}
          id="elegkui8n8ytu"
          fill="#000A18"
          className="animable"
        ></circle>
        <path
          d="M294.94 220.43a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 293.21,
            MsTransformOrigin: 293.21,
            transformOrigin: 293.21,
          }}
          id="el2dlu21at6n4"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M300.65 220.43a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 298.92,
            MsTransformOrigin: 298.92,
            transformOrigin: 298.92,
          }}
          id="el9tw2qe0h0bv"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M277.82 225.62a1.73 1.73 0 11-1.73-1.73 1.74 1.74 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 276.09,
            MsTransformOrigin: 276.09,
            transformOrigin: 276.09,
          }}
          id="el2zbhpze56xs"
          fill="#000A18"
          className="animable"
        ></path>
        <circle
          cx="281.8"
          cy="225.62"
          r="1.73"
          style={{
            WebkitTransformOrigin: 281.8,
            MsTransformOrigin: 281.8,
            transformOrigin: 281.8,
          }}
          id="eltasuj7f05nc"
          fill="#000A18"
          className="animable"
        ></circle>
        <circle
          cx="287.5"
          cy="225.62"
          r="1.73"
          style={{
            WebkitTransformOrigin: 287.5,
            MsTransformOrigin: 287.5,
            transformOrigin: 287.5,
          }}
          id="ele1206n27r2"
          fill="#000A18"
          className="animable"
        ></circle>
        <path
          d="M294.94 225.62a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 293.21,
            MsTransformOrigin: 293.21,
            transformOrigin: 293.21,
          }}
          id="el79bh2rtyhw6"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M300.65 225.62a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 298.92,
            MsTransformOrigin: 298.92,
            transformOrigin: 298.92,
          }}
          id="elkvjpwtwwh5l"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M277.82 230.82a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 276.09,
            MsTransformOrigin: 276.09,
            transformOrigin: 276.09,
          }}
          id="elnk0frhuqixe"
          fill="#000A18"
          className="animable"
        ></path>
        <circle
          cx="281.8"
          cy="230.82"
          r="1.73"
          style={{
            WebkitTransformOrigin: 281.8,
            MsTransformOrigin: 281.8,
            transformOrigin: 281.8,
          }}
          id="el6ap3e6hzsag"
          fill="#000A18"
          className="animable"
        ></circle>
        <circle
          cx="287.5"
          cy="230.82"
          r="1.73"
          style={{
            WebkitTransformOrigin: 287.5,
            MsTransformOrigin: 287.5,
            transformOrigin: 287.5,
          }}
          id="elpb8t8ir127"
          fill="#000A18"
          className="animable"
        ></circle>
        <path
          d="M294.94 230.82a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 293.21,
            MsTransformOrigin: 293.21,
            transformOrigin: 293.21,
          }}
          id="elm52damzthzh"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M300.65 230.82a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 298.92,
            MsTransformOrigin: 298.92,
            transformOrigin: 298.92,
          }}
          id="el7wwnoadzv8s"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 271.57,
            MsTransformOrigin: 271.57,
            transformOrigin: 271.57,
          }}
          id="elknq4yw09k8c"
          fill="#263238"
          d="M271.07 218.7H272.07V232.54999999999998H271.07z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 203.76,
            MsTransformOrigin: 203.76,
            transformOrigin: 203.76,
          }}
          id="elb3xnkok50xi"
          fill="#263238"
          d="M193.76 215.28H213.76V235.97H193.76z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 238.55,
            MsTransformOrigin: 238.55,
            transformOrigin: 238.55,
          }}
          id="el6qyojbzcngv"
          fill="#37474F"
          d="M193.76 190.35H283.34V211.04H193.76z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="elovqqhvgnn7"
          fill="#455A64"
          d="M197.53 193.76H248.52V195.51H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="elwlo02qx6h1"
          fill="#455A64"
          d="M197.53 196.79H248.52V198.54H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="el8s2s3nddixw"
          fill="#455A64"
          d="M197.53 199.82H248.52V201.57H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="elt52m2ricwwi"
          fill="#455A64"
          d="M197.53 202.85H248.52V204.6H197.53z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 223.025,
            MsTransformOrigin: 223.025,
            transformOrigin: 223.025,
          }}
          id="el7bujtulk6pg"
          fill="#455A64"
          d="M197.53 205.87H248.52V207.62H197.53z"
          className="animable"
        ></path>
        <path
          d="M257.82 195.5a1.73 1.73 0 11-1.73-1.74 1.74 1.74 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="el026jsaa49nos"
          fill="#000A18"
          className="animable"
        ></path>
        <circle
          cx="261.8"
          cy="195.5"
          r="1.73"
          style={{
            WebkitTransformOrigin: 261.8,
            MsTransformOrigin: 261.8,
            transformOrigin: 261.8,
          }}
          id="eluwfduqs6h1l"
          fill="#000A18"
          className="animable"
        ></circle>
        <circle
          cx="267.5"
          cy="195.5"
          r="1.73"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="el3m5e71hnw77"
          fill="#000A18"
          className="animable"
        ></circle>
        <path
          d="M274.94 195.5a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="elrn0mumec2q"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 195.5a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="elfomi2g98loo"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M257.82 200.69a1.73 1.73 0 11-1.73-1.73 1.73 1.73 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="ellnrz9e01y3"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M263.53 200.69a1.74 1.74 0 11-1.73-1.69 1.73 1.73 0 011.73 1.69z"
          style={{
            WebkitTransformOrigin: 261.791,
            MsTransformOrigin: 261.791,
            transformOrigin: 261.791,
          }}
          id="elgt0io24emkj"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M269.24 200.69a1.74 1.74 0 11-1.74-1.69 1.73 1.73 0 011.74 1.69z"
          style={{
            WebkitTransformOrigin: 267.501,
            MsTransformOrigin: 267.501,
            transformOrigin: 267.501,
          }}
          id="elvbjw7rl7y7l"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M274.94 200.69a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="elbl5tkn8txbj"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 200.69a1.73 1.73 0 11-1.73-1.73 1.72 1.72 0 011.73 1.73z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="el5wb52fwgnk"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M257.82 205.89a1.73 1.73 0 11-1.73-1.74 1.74 1.74 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 256.09,
            MsTransformOrigin: 256.09,
            transformOrigin: 256.09,
          }}
          id="eli9u0db53gp9"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M263.53 205.89a1.74 1.74 0 11-1.73-1.74 1.74 1.74 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 261.79,
            MsTransformOrigin: 261.79,
            transformOrigin: 261.79,
          }}
          id="el01czx5js31b3"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M269.24 205.89a1.74 1.74 0 11-1.74-1.74 1.74 1.74 0 011.74 1.74z"
          style={{
            WebkitTransformOrigin: 267.5,
            MsTransformOrigin: 267.5,
            transformOrigin: 267.5,
          }}
          id="elzyp2e52ot1s"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M274.94 205.89a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 273.21,
            MsTransformOrigin: 273.21,
            transformOrigin: 273.21,
          }}
          id="elinaec6idg4e"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M280.65 205.89a1.73 1.73 0 11-1.73-1.74 1.73 1.73 0 011.73 1.74z"
          style={{
            WebkitTransformOrigin: 278.92,
            MsTransformOrigin: 278.92,
            transformOrigin: 278.92,
          }}
          id="el0jcgdfgzfipg"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 251.57,
            MsTransformOrigin: 251.57,
            transformOrigin: 251.57,
          }}
          id="elfvv0wen8mit"
          fill="#263238"
          d="M251.07 193.76H252.07V207.60999999999999H251.07z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 209.69,
            MsTransformOrigin: 209.69,
            transformOrigin: 209.69,
          }}
          id="el198v8g0w20g"
          fill="#37474F"
          d="M150.65 173.13H268.73V179.69H150.65z"
          className="animable"
        ></path>
      </g>
      <g
        id="freepik--Floor--inject-32"
        className="animable"
        style={{
          WebkitTransformOrigin: 250,
          MsTransformOrigin: 250,
          transformOrigin: 250,
        }}
      >
        <path
          style={{
            WebkitTransformOrigin: 250,
            MsTransformOrigin: 250,
            transformOrigin: 250,
          }}
          id="elsukg1nawxvs"
          fill="#263238"
          d="M29.71 392.48L84.78 392.24 139.85 392.15 250 391.98 360.15 392.15 415.22 392.23 470.29 392.48 415.22 392.72 360.15 392.81 250 392.98 139.85 392.81 84.78 392.72 29.71 392.48z"
          className="animable"
        ></path>
      </g>
      <g
        id="freepik--Character--inject-32"
        className="animable"
        style={{
          WebkitTransformOrigin: 360.641,
          MsTransformOrigin: 360.641,
          transformOrigin: 360.641,
        }}
      >
        <path
          d="M309.92 438.31c2.17.72 64.32.54 66.69-1 .89-.57 1.39-9.63 1.69-20.58.07-2.37.15-40.51.15-40.51H338l.24 40.51s-23.76 10.72-26.17 12.65-4.32 8.21-2.15 8.93z"
          style={{
            WebkitTransformOrigin: 343.711,
            MsTransformOrigin: 343.711,
            transformOrigin: 343.711,
          }}
          id="elx18psai94l8"
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M378.15 421.57c-.31 8.69-.79 15.3-1.55 15.78-2.36 1.5-64.51 1.68-66.69 1s-.26-7 2.14-8.89c1.33-1.06 9.11-4.78 15.84-7.91-2.35 1.46-5.35 3.53-5.08 4.76.52 2.37 31.47 3.94 55.34-4.74z"
          style={{
            WebkitTransformOrigin: 343.553,
            MsTransformOrigin: 343.553,
            transformOrigin: 343.553,
          }}
          id="elekzi1cmup3"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M393.31 203.85S382.37 312 382.12 313.37c0 .18-.12 2.26-.22 5.66-.59 18.61-1.26 82.12-1.26 82.12H336s2.12-74.21 3.79-90.25c2.13-20.47 15.65-107 15.65-107z"
          style={{
            WebkitTransformOrigin: 364.655,
            MsTransformOrigin: 364.655,
            transformOrigin: 364.655,
          }}
          id="eldmee0lonz4s"
          fill="#37474F"
          className="animable"
        ></path>
        <path
          d="M376.8 317.18q2.06-35.15 6.2-70.13c1.57-13.14 3.45-26.24 5.33-39.33 0-.12.19-.11.18 0-3.45 23.31-5.9 46.81-8 70.28-.74 8.29-2.15 22.57-2.9 39.22-1.37 30.4-2 66.77-2.23 75.38a.25.25 0 01-.49 0c.62-23.76.51-51.7 1.91-75.42z"
          style={{
            WebkitTransformOrigin: 381.7,
            MsTransformOrigin: 381.7,
            transformOrigin: 381.7,
          }}
          id="elimfrp82qv"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M339.09 393.75c20.33-.64 37.93-.19 39.45-.07 1.26.1.56.23-.07.27-17.26 1-38.71.06-39.38 0a.09.09 0 010-.2z"
          style={{
            WebkitTransformOrigin: 359.116,
            MsTransformOrigin: 359.116,
            transformOrigin: 359.116,
          }}
          id="elb79k755s5tl"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M393.31 203.85S382.37 312 382.12 313.37c0 .18-.12 2.26-.22 5.66l-21-115.18z"
          style={{
            WebkitTransformOrigin: 377.105,
            MsTransformOrigin: 377.105,
            transformOrigin: 377.105,
          }}
          id="elqmjzu94391g"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M380.41 443.7c2.26.39 64.9-9.26 67-11.1.81-.68-10.33-60-10.33-60l-40.88 6 7.52 40.59s-20.41 13.09-22.52 15.35-3.04 8.76-.79 9.16z"
          style={{
            WebkitTransformOrigin: 413.28,
            MsTransformOrigin: 413.28,
            transformOrigin: 413.28,
          }}
          id="elhyokl1ovwli"
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M447.42 432.6c-2.12 1.84-64.76 11.49-67 11.1s-1.28-6.87.82-9.12c1.22-1.31 8.56-6.23 14.53-10.16-2.12 1.84-5.1 4.64-4.61 5.88.91 2.3 31.81-1.35 53.89-14 1.55 9.13 2.64 16.07 2.37 16.3z"
          style={{
            WebkitTransformOrigin: 413.299,
            MsTransformOrigin: 413.299,
            transformOrigin: 413.299,
          }}
          id="ellgpzzaraub"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M355.47 203.85s1.31 11 7.63 19c1.51 1.9 6.16 3.67 8.56 5.42 0 0 9 82.46 11.71 91.8 3 10.37 14.88 81.31 14.88 81.31l46-6.34s-13.37-66.55-16.69-83.8c-.75-3.85-10.73-76.42-10.5-78.1 2.68-20-7-29.24-7-29.24z"
          style={{
            WebkitTransformOrigin: 399.86,
            MsTransformOrigin: 399.86,
            transformOrigin: 399.86,
          }}
          id="elz7jtfr45zi9"
          fill="#37474F"
          className="animable"
        ></path>
        <path
          d="M390.59 204.64a19.8 19.8 0 005.55 9.88 18.09 18.09 0 0010.1 5.1c.6.06.52.47-.11.46-7.28 0-14.68-5.93-15.84-15.39a.15.15 0 11.3-.05z"
          style={{
            WebkitTransformOrigin: 398.468,
            MsTransformOrigin: 398.468,
            transformOrigin: 398.468,
          }}
          id="el9ophjnte5dm"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M362.24 222.47a40.05 40.05 0 017.51 4c2.5 1.54 4.81 3.35 7.22 5 .09.07 0 .22-.09.16-2.53-1.46-5.16-2.72-7.66-4.22a47.67 47.67 0 01-7.09-4.75.12.12 0 01.11-.19z"
          style={{
            WebkitTransformOrigin: 369.557,
            MsTransformOrigin: 369.557,
            transformOrigin: 369.557,
          }}
          id="elxns5k61bwb"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M361.21 207.31c.39 1.66.88 3.31 1.32 5s.73 3.14 1.22 4.67a8.06 8.06 0 002.37 3.85c.64.55 1.34 1 2 1.51.37.27.76.52 1.14.79l-.15-.67-.42-1.9c-.3-1.4-.59-2.81-.87-4.22-.56-2.77-1.08-5.57-1.78-8.3a.09.09 0 01.17-.05c.82 2.7 1.71 5.37 2.44 8.11.36 1.34 1.72 8 1.79 8.44s.13 1 .17 1.46a5.81 5.81 0 01.07 1.5c0 .12-.17.11-.22 0a6 6 0 01-.49-1.44 14.35 14.35 0 01-.38-1.43c0-.17-.08-.35-.11-.53-.67-.37-1.31-.87-1.95-1.28s-1.38-.89-2-1.39a7.55 7.55 0 01-2.57-3.64 28.59 28.59 0 01-1-4.76c-.29-1.89-.54-3.79-.89-5.67-.07-.11.12-.17.14-.05z"
          style={{
            WebkitTransformOrigin: 365.877,
            MsTransformOrigin: 365.877,
            transformOrigin: 365.877,
          }}
          id="el1ji11wuje9rj"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M400.39 392.26c20-3.47 37.53-5.47 39.05-5.56 1.26-.08.59.15 0 .27-17 3.43-38.32 5.46-39 5.47a.09.09 0 01-.05-.18z"
          style={{
            WebkitTransformOrigin: 420.239,
            MsTransformOrigin: 420.239,
            transformOrigin: 420.239,
          }}
          id="eln7patk3mq2n"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M430.36 346.72c-2.63-11.53-5-23.1-7-34.77s-3.52-23.28-5-35-3-23.56-4.52-35.34A49.85 49.85 0 01413 233c.13-2.83 1.1-5.55 1.37-8.36a37.8 37.8 0 00-2.31-16.1c-.46-1.3-1-2.58-1.53-3.85-.07-.16-.34-.09-.28.09 1.77 5.33 3.4 10.8 3.48 16.46a38.44 38.44 0 01-1.1 8.54 24.49 24.49 0 00-.15 8.28c1.46 11.73 3 23.46 4.49 35.18s3 23.36 4.88 35 4 23.11 6.65 34.56 5.33 23.06 8.22 34.54c.36 1.43.72 2.85 1.09 4.27 0 .17.29.09.25-.08-2.3-11.69-5.06-23.24-7.7-34.81z"
          style={{
            WebkitTransformOrigin: 424.153,
            MsTransformOrigin: 424.153,
            transformOrigin: 424.153,
          }}
          id="ell4qj8huhkeq"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M385.91 100.87c6.49 5 9.32 14.26 9.32 14.26s6.73 8.83 5.83 14.18a9.53 9.53 0 01-5.2 7.12l.19-2.93s-1.39 3.9-7.41 6.16-14.44 1.37-19-.26a16.44 16.44 0 01-7-4.73l2.12 4a12.41 12.41 0 01-10.42-5.41c-4.37-6 4.74-16.44 5.36-18.53s0-16.73 15.5-16.11c0 0 6.24-1.2 10.71 2.25z"
          style={{
            WebkitTransformOrigin: 377.15,
            MsTransformOrigin: 377.15,
            transformOrigin: 377.15,
          }}
          id="elw3lyk0jjen"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M398 135.78a13.84 13.84 0 003.49-4.71 9 9 0 00.25-5.81 20 20 0 00-3.66-6.05c-1.49-1.92-3.14-3.74-4.6-5.69-.08-.11.08-.22.18-.14a53.3 53.3 0 014.39 4.5 26 26 0 013.62 4.72 9.66 9.66 0 011.36 5.23 9.35 9.35 0 01-1.4 4.23 19.46 19.46 0 01-3.53 3.83.07.07 0 11-.1-.11z"
          style={{
            WebkitTransformOrigin: 398.246,
            MsTransformOrigin: 398.246,
            transformOrigin: 398.246,
          }}
          id="elj9tudvumayd"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M352.31 126.79c1.15-5.54 5.51-9.51 7.84-14.51 1.26-2.7 2.13-5.63 3.91-8.07.05-.06.16 0 .12.08-1.44 2.18-2.12 4.66-3.05 7.06a39.73 39.73 0 01-3.74 6.83c-2.56 4-5.63 8.7-4.31 13.67.61 2.29 2.31 4.7 4.8 5.13.09 0 .05.17 0 .15a7.57 7.57 0 01-4.7-3.67 9.62 9.62 0 01-.87-6.67z"
          style={{
            WebkitTransformOrigin: 358.125,
            MsTransformOrigin: 358.125,
            transformOrigin: 358.125,
          }}
          id="elnxg75thpq1"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M352.27 128.25a9.88 9.88 0 01.6-5.93 13.93 13.93 0 013.84-4.59c1.74-1.5 3.6-3 4.55-5.11 0-.09.17 0 .14.08-1.51 3.54-4.95 5.53-7.07 8.62-2.42 3.53-1.84 8.16.55 11.55a16.29 16.29 0 005.76 4.89v.06c-3.91-1.91-7.53-5.14-8.37-9.57z"
          style={{
            WebkitTransformOrigin: 356.733,
            MsTransformOrigin: 356.733,
            transformOrigin: 356.733,
          }}
          id="elm417qesu67o"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M378.27 147c-7.4 19.58-16.62 35.61-22.8 38.72-5 2.51-43.86 4.16-45.2 4.1-3.3-.17-6.18-22.46-3.55-24.84.61-.54 37.42 1.62 38.75.61s14.32-13.76 24.66-23.51c7.24-6.86 12.25-5.96 8.14 4.92z"
          style={{
            WebkitTransformOrigin: 342.722,
            MsTransformOrigin: 342.722,
            transformOrigin: 342.722,
          }}
          id="elj6ap6cpz58g"
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M317.11 188.37a80.93 80.93 0 01-10.18 2.46c-2.73.36-10.62 1.18-11.31-1.79-.48-2 4.11-3 7.33-3.85 1.7-.42 3.92-1.79 3.61-2.89-.55-1.92-4.93-.74-7.88.41-5.69 2.24-13.49 6.64-16.28 3.5-1-1.19.63-2.8 3-4.27-3.64 1.57-7.45 2.74-8.68 1.47a1.78 1.78 0 010-2.44 2.36 2.36 0 01-2.51-.79c-.91-1.3-.12-2.89 1.32-4.42a1.33 1.33 0 01-.88-.8c-1.76-3.84 11.24-12.11 15.35-12.44a89.15 89.15 0 0124.34 1.92c3.95 4.36 2.78 23.92 2.77 23.93z"
          style={{
            WebkitTransformOrigin: 295.55,
            MsTransformOrigin: 295.55,
            transformOrigin: 295.55,
          }}
          id="elhddtvgkcyjj"
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M301.62 174.87a19.21 19.21 0 00-8.24 1.8c-3 1.45-5.56 3.68-8.4 5.41-.07 0 0 .16.08.11 1.35-.91 2.8-1.69 4.19-2.55s2.69-1.72 4.09-2.46a19.1 19.1 0 018.28-2.26s.03-.05 0-.05z"
          style={{
            WebkitTransformOrigin: 293.292,
            MsTransformOrigin: 293.292,
            transformOrigin: 293.292,
          }}
          id="el4vws8ialmka"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M300.2 169.59a46.78 46.78 0 00-9.53 1.75c-3.35 1.11-6.19 3.32-9 5.44q-2.5 1.92-4.92 3.94c-.07.05 0 .17.08.12q4.23-3.3 8.67-6.35a25.17 25.17 0 019-3.94c1.85-.4 3.74-.65 5.62-.91.12 0 .12-.06.08-.05z"
          style={{
            WebkitTransformOrigin: 288.473,
            MsTransformOrigin: 288.473,
            transformOrigin: 288.473,
          }}
          id="elndtgic2ilue"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M297.59 164.76c-3.07.15-5.75.28-8.63 1.47a43.23 43.23 0 00-9.11 5.7c-1.52 1.2-3 2.44-4.45 3.71-.06.05 0 .16.09.11a98.63 98.63 0 0110.51-7.61 19.93 19.93 0 015.58-2.53 36.5 36.5 0 016.06-.83s-.03-.02-.05-.02z"
          style={{
            WebkitTransformOrigin: 286.508,
            MsTransformOrigin: 286.508,
            transformOrigin: 286.508,
          }}
          id="elssbd9o7fwce"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M313.72 163.61l3 28.18s30.49-1.47 39.51-6.1 19.11-29.57 23-40.46-4.3-8.56-9.82-3.49-23.73 22.52-24.31 22.9-31.38-1.03-31.38-1.03z"
          style={{
            WebkitTransformOrigin: 346.981,
            MsTransformOrigin: 346.981,
            transformOrigin: 346.981,
          }}
          id="elkd927kiue9r"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M341.76 184.87a1.36 1.36 0 00-.89 1.26 1.07 1.07 0 01-.5.92 1.1 1.1 0 01-.56.19c-.23 0-.46.07-.68.13a2.45 2.45 0 001.43.06 1.4 1.4 0 00.84-1.29 1.09 1.09 0 011.11-1.06c.22-.05.45-.08.68-.14a2.74 2.74 0 00-1.43-.07zM325.32 186a1.37 1.37 0 00-.89 1.26 1 1 0 01-.49.92 1.14 1.14 0 01-.57.19 5.28 5.28 0 00-.67.13 2.43 2.43 0 001.42.05 1.38 1.38 0 00.85-1.28 1.08 1.08 0 01.52-.9 1.17 1.17 0 01.59-.17c.22 0 .44-.07.67-.13a2.73 2.73 0 00-1.43-.07zm16.92-15.55a1.36 1.36 0 00-.89 1.26 1.08 1.08 0 01-.5.92 1.1 1.1 0 01-.56.19 5.1 5.1 0 00-.68.13 2.46 2.46 0 001.43 0 1.39 1.39 0 00.84-1.28 1.1 1.1 0 01.52-.9 1.2 1.2 0 01.59-.17c.22 0 .45-.07.68-.13a2.74 2.74 0 00-1.43-.04zm-26.75-6.74a1.24 1.24 0 000 .27 1.08 1.08 0 01-.5.92 1.1 1.1 0 01-.56.19 4.59 4.59 0 00-.51.1.51.51 0 00-.17 0h.17a2.06 2.06 0 001.26 0A1.41 1.41 0 00316 164a.75.75 0 010-.26zm55.59-1a1.35 1.35 0 00-.88 1.26 1.07 1.07 0 01-.5.92 1.14 1.14 0 01-.57.19c-.22 0-.45.07-.67.13a2.42 2.42 0 001.42.06 1.41 1.41 0 00.85-1.29 1.11 1.11 0 01.52-.9 1.08 1.08 0 01.59-.16h.22c0-.06.05-.11.07-.16a1.87 1.87 0 00-1.05-.06zm-19.74-.64a1.39 1.39 0 00-.89 1.27 1 1 0 01-.49.92 1.13 1.13 0 01-.57.18c-.22 0-.45.07-.67.13a2.35 2.35 0 001.42.06 1.38 1.38 0 00.85-1.28 1.1 1.1 0 01.52-.9 1.17 1.17 0 01.59-.17l.67-.13a2.62 2.62 0 00-1.43-.09zm22.26-12.27a1.37 1.37 0 00-1.5.31 1.08 1.08 0 01-1.53 0c-.19-.13-.38-.26-.58-.38a2.61 2.61 0 001 1.06 1.37 1.37 0 001.52-.26 1.12 1.12 0 011.53 0 4.52 4.52 0 00.58.39c-.31-.44-.5-.92-1.02-1.12zM334 179a1.36 1.36 0 00-1.5.31 1.08 1.08 0 01-1 .26 1.19 1.19 0 01-.52-.29c-.2-.13-.38-.27-.58-.39a2.71 2.71 0 001 1.07 1.39 1.39 0 001.51-.27 1.11 1.11 0 011-.3 1 1 0 01.53.27c.2.13.37.27.58.39-.27-.42-.46-.87-1.02-1.05zm.37-14.49l-1.7-.06a.65.65 0 00-.16.13 1.08 1.08 0 01-1 .26 1.19 1.19 0 01-.52-.29l-.26-.18h-.18a2 2 0 00.82.87 1.35 1.35 0 001.51-.27 1.11 1.11 0 011-.3 1 1 0 01.53.27c.2.13.37.27.58.39a4.53 4.53 0 00-.58-.86zM317.79 179a1.38 1.38 0 00-1.51.31 1 1 0 01-.85.28l.05.47a1.4 1.4 0 001.17-.37 1.1 1.1 0 011-.3 1.08 1.08 0 01.53.27c.2.13.37.27.57.39-.25-.42-.44-.87-.96-1.05zm34-.6a1.38 1.38 0 00-1.51.31 1.06 1.06 0 01-1 .26 1.27 1.27 0 01-.53-.29c-.19-.13-.37-.27-.57-.39a2.57 2.57 0 001 1.07 1.37 1.37 0 001.51-.26 1.09 1.09 0 011-.31 1.08 1.08 0 01.53.27c.2.13.37.27.58.39-.32-.45-.51-.87-1.03-1.09zm9.08-6.7a1.43 1.43 0 00-1.29-.84 1.08 1.08 0 01-.9-.52 1.28 1.28 0 01-.17-.58c0-.22-.07-.45-.13-.68a2.73 2.73 0 00-.07 1.43 1.36 1.36 0 001.26.88 1.12 1.12 0 01.93.51 1.16 1.16 0 01.18.56c0 .23.07.45.13.68a2.49 2.49 0 00.04-1.48zm1.36-13a1.39 1.39 0 00-1.28-.84 1.1 1.1 0 01-.9-.52 1.17 1.17 0 01-.17-.58c0-.23-.07-.46-.13-.68a2.63 2.63 0 00-.07 1.43 1.34 1.34 0 001.25.88 1.11 1.11 0 01.93.5 1.2 1.2 0 01.19.57 4.16 4.16 0 00.13.67 2.46 2.46 0 00.03-1.49zM326 172.48a1.35 1.35 0 00-1.28-.84 1.06 1.06 0 01-.89-.53 1.24 1.24 0 01-.18-.58 5.28 5.28 0 00-.13-.67 2.69 2.69 0 00-.07 1.42 1.36 1.36 0 001.27.89 1.11 1.11 0 011.1 1.07c.05.22.07.44.13.67a2.38 2.38 0 00.05-1.43z"
          style={{
            WebkitTransformOrigin: 344.185,
            MsTransformOrigin: 344.185,
            transformOrigin: 344.185,
          }}
          id="elunkgtl4l0p"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M324 190.33a62.77 62.77 0 00-.68-6.28q-.39-3.08-.83-6.15c-.58-4.13-1.07-8.3-1.92-12.39a.08.08 0 00-.15 0c.18 4.2.79 8.4 1.35 12.57q.42 3.14.93 6.25a52.64 52.64 0 001.14 6c0 .13.16.08.16 0z"
          style={{
            WebkitTransformOrigin: 322.21,
            MsTransformOrigin: 322.21,
            transformOrigin: 322.21,
          }}
          id="elhi6y0g8bjyq"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M379.22 145.23c-3.86 10.89-13.94 35.83-23 40.46-4.51 2.31-14.37 3.84-23.12 4.79l43.52-52.9c3.03-.58 4.84 1.32 2.6 7.65z"
          style={{
            WebkitTransformOrigin: 356.66,
            MsTransformOrigin: 356.66,
            transformOrigin: 356.66,
          }}
          id="ele4cfewr7p4e"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M311.87 302.66c-9.78 0-12.76-30.71-14.15-53.8-.09-1.46-.16-2.63-.22-3.45-.88-11.78-1.77-14.09-10-14.09v-1c9.39 0 10.16 3.86 11 15 .06.82.13 2 .22 3.47.78 13.07 3.18 52.86 13.15 52.86 9.38 0 10.82-20.87 12.35-43 .51-7.42 1-15.09 1.89-22.07 2.82-23 7.08-33.27 13.83-33.27v1c-6.05 0-10.13 10.29-12.83 32.39-.86 7-1.38 14.61-1.9 22-1.55 22.63-3.03 43.96-13.34 43.96z"
          style={{
            WebkitTransformOrigin: 313.72,
            MsTransformOrigin: 313.72,
            transformOrigin: 313.72,
          }}
          id="ely7zr0twl9d"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 289.175,
            MsTransformOrigin: 289.175,
            transformOrigin: 289.175,
          }}
          id="elnglqf4m1uci"
          fill="#DBDBDB"
          d="M286.87 230.09H291.48V231.84H286.87z"
          className="animable"
        ></path>
        <path
          d="M316.24 296.27c-10.95 0-12.05-33.81-12.58-50-.09-2.65-.16-4.75-.25-6-.89-11.78-1.78-14.09-10-14.09v-1c9.39 0 10.16 3.86 11 15 .09 1.28.16 3.38.25 6 .48 14.69 1.6 49.09 11.58 49.09 8.15 0 9.06-21.06 10-43.35.21-4.75.42-9.66.71-14.46 1.83-30.79 10.87-34.11 14.67-34.11v1c-3.52 0-11.89 3.23-13.67 33.17-.29 4.79-.5 9.7-.71 14.44-1.01 23.78-1.9 44.31-11 44.31z"
          style={{
            WebkitTransformOrigin: 317.515,
            MsTransformOrigin: 317.515,
            transformOrigin: 317.515,
          }}
          id="el7m4qs858rzu"
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 295.085,
            MsTransformOrigin: 295.085,
            transformOrigin: 295.085,
          }}
          id="elo93oa9ub6w"
          fill="#DBDBDB"
          d="M292.78 224.75H297.39V226.5H292.78z"
          className="animable"
        ></path>
        <path
          d="M359.62 179.08l-4.88 24.64s4.86.3 11.92.69l3.73-6 4.43 6.49c15.37.82 31.73.66 38.93.48 0 0-7.12-47.59-19.8-62.69-6.33-7.55-14.19-7.36-19.42-2.53-1.32 1.22-15.28 17.18-17.22 24.72-1.69 6.61 2.31 14.2 2.31 14.2z"
          style={{
            WebkitTransformOrigin: 384.245,
            MsTransformOrigin: 384.245,
            transformOrigin: 384.245,
          }}
          id="elhsonopacztg"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M402.17 188a1.38 1.38 0 00-1.28-.84 1.06 1.06 0 01-.89-.52 1.28 1.28 0 01-.18-.58 5.79 5.79 0 00-.13-.68 2.73 2.73 0 00-.07 1.43 1.35 1.35 0 001.27.88 1.11 1.11 0 01.92.51 1.06 1.06 0 01.18.56c.05.23.07.45.13.68a2.41 2.41 0 00.05-1.44zm-4.8-22.41a1.39 1.39 0 00-1.29-.85 1.05 1.05 0 01-.9-.53 1.2 1.2 0 01-.16-.57c0-.23-.07-.46-.13-.69a2.67 2.67 0 00-.07 1.44 1.36 1.36 0 001.25.89 1.07 1.07 0 01.92.49 1 1 0 01.19.57c0 .23.07.45.13.68a2.46 2.46 0 00.06-1.44zm-11.86-22.69a1.39 1.39 0 00-1.28-.85 1.05 1.05 0 01-.9-.52 1.24 1.24 0 01-.17-.58 5.79 5.79 0 00-.13-.68 2.64 2.64 0 00-.07 1.43 1.36 1.36 0 001.26.89 1.09 1.09 0 01.92.49 1.17 1.17 0 01.19.57c0 .23.07.46.13.68a2.46 2.46 0 00.05-1.44zm-1.18 15.17a1.38 1.38 0 00-1.28-.84 1.05 1.05 0 01-.9-.52 1.16 1.16 0 01-.16-.58c-.05-.22-.07-.45-.14-.68a2.74 2.74 0 00-.07 1.43 1.37 1.37 0 001.26.89 1.11 1.11 0 01.93.49 1.13 1.13 0 01.18.57c.05.23.07.46.13.68a2.41 2.41 0 00.05-1.45zm-22.12.58a1.39 1.39 0 00-1.28-.84.41.41 0 01-.16 0c-.1.16-.2.32-.29.48a1.32 1.32 0 00.44.08 1.11 1.11 0 01.93.5 1.2 1.2 0 01.19.57 4.16 4.16 0 00.13.67 2.46 2.46 0 00.04-1.47zm-1.36 13a1.43 1.43 0 00-1.29-.84 1.08 1.08 0 01-.9-.52 1.28 1.28 0 01-.17-.58c0-.22-.07-.45-.13-.68a2.73 2.73 0 00-.07 1.43 1.36 1.36 0 001.26.88 1.12 1.12 0 01.93.51 1.16 1.16 0 01.18.56c0 .23.07.45.13.68a2.49 2.49 0 00.06-1.43zM381 188a1.41 1.41 0 00-1.28-.84 1.08 1.08 0 01-.9-.52 1.17 1.17 0 01-.17-.58c0-.22-.07-.45-.13-.68a2.63 2.63 0 00-.07 1.43 1.35 1.35 0 001.26.88 1.11 1.11 0 01.92.51 1.16 1.16 0 01.19.56c0 .23.07.45.13.68A2.49 2.49 0 00381 188zm11.71 6.9a1.36 1.36 0 00-1.5.31 1.11 1.11 0 01-1 .26 1.27 1.27 0 01-.53-.29c-.19-.14-.37-.27-.57-.39a2.55 2.55 0 001 1.06 1.33 1.33 0 001.51-.26 1.11 1.11 0 011-.3 1.14 1.14 0 01.53.26c.2.14.37.28.58.4-.31-.39-.5-.84-1.02-1.06zm-21.41-16.54a1.36 1.36 0 00-1.5.31 1.06 1.06 0 01-1 .26 1.16 1.16 0 01-.53-.29c-.2-.13-.37-.27-.57-.39a2.55 2.55 0 00.95 1.07 1.38 1.38 0 001.52-.26 1.11 1.11 0 011.54 0c.19.13.36.27.57.39-.28-.45-.46-.87-.98-1.09zm-.46 15.93a1.39 1.39 0 00-1.51.31 1.06 1.06 0 01-1 .26 1.08 1.08 0 01-.53-.29c-.19-.13-.37-.27-.57-.39a2.57 2.57 0 001 1.07 1.37 1.37 0 001.51-.26 1.11 1.11 0 011-.31 1.08 1.08 0 01.53.27c.19.13.37.27.57.39-.29-.34-.48-.82-1-1.05zm36.57-19.35a1.41 1.41 0 00-1.51.31 1.07 1.07 0 01-1 .26 1.09 1.09 0 01-.52-.29c-.19-.12-.37-.27-.58-.38a2.83 2.83 0 001 1.06 1.37 1.37 0 001.53-.27 1.06 1.06 0 011-.3.79.79 0 01.26.08zm.78 23.52a1.44 1.44 0 00-1.51.32 1.06 1.06 0 01-1 .26 1 1 0 01-.53-.29c-.19-.12-.37-.27-.57-.38a2.65 2.65 0 00.95 1.06 1.38 1.38 0 001.53-.26 1 1 0 011-.3 1 1 0 01.53.27c.19.12.36.27.57.38a2.51 2.51 0 00-.97-1.06zM373.6 149.8a1.37 1.37 0 00-1.5.31 1.08 1.08 0 01-1.53 0c-.19-.13-.38-.26-.58-.38a2.61 2.61 0 001 1.06 1.37 1.37 0 001.52-.26 1.12 1.12 0 011.53 0 4.52 4.52 0 00.58.39c-.31-.44-.5-.92-1.02-1.12zm9.79 20.83a1.37 1.37 0 00-1.5.31 1.08 1.08 0 01-1 .26 1.05 1.05 0 01-.52-.29c-.19-.13-.37-.27-.58-.39a2.71 2.71 0 001 1.07 1.37 1.37 0 001.52-.27 1.09 1.09 0 011-.3 1 1 0 01.52.27c.19.13.37.27.58.39-.31-.37-.49-.83-1.02-1.05zm-12.31-7.93a1.35 1.35 0 00-.88 1.26 1.07 1.07 0 01-.5.92 1.14 1.14 0 01-.57.19c-.22 0-.45.07-.67.13a2.42 2.42 0 001.42.06 1.41 1.41 0 00.85-1.29 1.11 1.11 0 01.52-.9 1.08 1.08 0 01.59-.16c.22 0 .44-.08.68-.14a2.77 2.77 0 00-1.44-.07zm-10.91 22.39a1.37 1.37 0 00-.88 1.26 1.08 1.08 0 01-.5.93 1.13 1.13 0 01-.57.18h-.27a2.83 2.83 0 00-.4.08l.37.08a1.65 1.65 0 001.05 0 1.39 1.39 0 00.85-1.28 1.13 1.13 0 01.52-.91 1.28 1.28 0 01.59-.16l.67-.13a2.72 2.72 0 00-1.43-.05zm.93 16.91a1.37 1.37 0 00-.88 1.26 1 1 0 01-.3.76h.59a1.28 1.28 0 00.24-.77 1.1 1.1 0 01.52-.9 1.17 1.17 0 01.59-.17l.68-.13a2.77 2.77 0 00-1.44-.05zm19.9-1.17a1.34 1.34 0 00-.89 1.26 1.08 1.08 0 01-.5.92 1 1 0 01-.56.19c-.23 0-.46.07-.68.13a2.38 2.38 0 001.43 0 1.38 1.38 0 00.84-1.28 1.1 1.1 0 01.52-.9 1.13 1.13 0 01.59-.16l.67-.13a2.51 2.51 0 00-1.42-.02zm10.64-22.59a1.37 1.37 0 00-.89 1.25 1.09 1.09 0 01-.48.93 1.28 1.28 0 01-.58.19c-.22 0-.44.07-.67.13a2.55 2.55 0 001.43.05 1.39 1.39 0 00.84-1.29 1.07 1.07 0 01.52-.89 1.2 1.2 0 01.58-.17c.23 0 .45-.07.68-.13a2.63 2.63 0 00-1.43-.06zM396 148.5a1.39 1.39 0 00-.89 1.27 1.06 1.06 0 01-.49.92 1.13 1.13 0 01-.57.18c-.22 0-.45.07-.68.14a2.47 2.47 0 001.43.05 1.39 1.39 0 00.85-1.29 1.07 1.07 0 01.52-.89 1.17 1.17 0 01.58-.17c.23 0 .46-.07.68-.13a2.63 2.63 0 00-1.43-.08z"
          style={{
            WebkitTransformOrigin: 383.355,
            MsTransformOrigin: 383.355,
            transformOrigin: 383.355,
          }}
          id="elrfrqnzi12l9"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M356.53 195.31c.68-2.78 1.2-5 1.8-7.75s1.23-5.58 1.8-8.38V179l-.11-.19a21.54 21.54 0 01-2.5-7.25 15.83 15.83 0 01-.16-3.83 13.13 13.13 0 01.78-3.72 45.45 45.45 0 013.46-7c1.34-2.26 2.44-4.16 3.92-6.36.24-.34.11-.43-.11-.16-1.46 1.78-3.08 4.26-4.35 6.19a39.12 39.12 0 00-3.85 7 13.32 13.32 0 00-.92 4 16.89 16.89 0 00.13 4.08 21.19 21.19 0 002.74 7.63l-.07-.38c-.52 2.81-1 5.63-1.45 8.45-.43 2.53-.91 5.26-1.27 7.81-.01.26-.07 1.06.16.04z"
          style={{
            WebkitTransformOrigin: 360.936,
            MsTransformOrigin: 360.936,
            transformOrigin: 360.936,
          }}
          id="eltfhoz23mlcd"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M363 152.61a12.11 12.11 0 00-1.51 2.57 11.06 11.06 0 00-.53 1.39 6.17 6.17 0 00-.3 1.48c.48-.88.93-1.75 1.34-2.65a17.44 17.44 0 001-2.79z"
          style={{
            WebkitTransformOrigin: 361.83,
            MsTransformOrigin: 361.83,
            transformOrigin: 361.83,
          }}
          id="elrulvi7qu1b"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M377.56 144.92c-.61 4.85-1.34 9.68-2.07 14.51s-1.57 9.64-2.34 14.47-1.67 9.62-2.57 14.42l-1.36 7.2c-.49 2.4-1 4.8-1.47 7.19.3-2.43.66-4.85 1-7.27l1.09-7.25c.73-4.82 1.56-9.64 2.33-14.46s1.67-9.63 2.57-14.43 1.8-9.6 2.82-14.38z"
          style={{
            WebkitTransformOrigin: 372.655,
            MsTransformOrigin: 372.655,
            transformOrigin: 372.655,
          }}
          id="elpu0gcnogp9g"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M371.49 159.09a.92.92 0 001.8.34.92.92 0 10-1.8-.34z"
          style={{
            WebkitTransformOrigin: 372.406,
            MsTransformOrigin: 372.406,
            transformOrigin: 372.406,
          }}
          id="elh8fhibv62v"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M370.1 168.43a.92.92 0 00.73 1.07.93.93 0 001.07-.73.92.92 0 00-.73-1.07.91.91 0 00-1.07.73z"
          style={{
            WebkitTransformOrigin: 371,
            MsTransformOrigin: 371,
            transformOrigin: 371,
          }}
          id="elvtdko0b5w5"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M368.7 177.76a.92.92 0 001.8.34.91.91 0 00-.73-1.07.92.92 0 00-1.07.73z"
          style={{
            WebkitTransformOrigin: 369.606,
            MsTransformOrigin: 369.606,
            transformOrigin: 369.606,
          }}
          id="elh7bo26ycs8h"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M367.31 187.09a.92.92 0 101.07-.73.93.93 0 00-1.07.73z"
          style={{
            WebkitTransformOrigin: 368.213,
            MsTransformOrigin: 368.213,
            transformOrigin: 368.213,
          }}
          id="elsggnr0plxm"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M365.92 196.43a.92.92 0 101.8.34.92.92 0 10-1.8-.34z"
          style={{
            WebkitTransformOrigin: 366.82,
            MsTransformOrigin: 366.82,
            transformOrigin: 366.82,
          }}
          id="elhusi5coktoe"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M395.21 142.43c17.83 15.82 39.68 50.1 36.24 57.58-3.83 8.33-29.94-13.45-29.29-14.69.55-1-9.24-17.88-15.5-36-5.53-16.03 4.14-10.81 8.55-6.89z"
          style={{
            WebkitTransformOrigin: 408.404,
            MsTransformOrigin: 408.404,
            transformOrigin: 408.404,
          }}
          id="elhv9u1skss1"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M423.38 198.26a1.38 1.38 0 00-1.28-.84 1.09 1.09 0 01-.9-.53 1.11 1.11 0 01-.17-.58c0-.22-.07-.45-.13-.67a2.72 2.72 0 00-.08 1.43 1.37 1.37 0 001.27.88 1.12 1.12 0 01.93.5 1.1 1.1 0 01.17.57c.06.22.08.44.13.67a2.38 2.38 0 00.06-1.43zm.12-20.34a1.06 1.06 0 01-.89-.52 1.28 1.28 0 01-.18-.58c0-.22-.07-.45-.13-.68a2.73 2.73 0 00-.07 1.43 1.35 1.35 0 001.27.88 1.06 1.06 0 01.4.08zm1.11 1.9c0 .12.05.25.08.38v-.18zm-8.5-11a1.38 1.38 0 00-1.28-.85 1.05 1.05 0 01-.9-.52 1.16 1.16 0 01-.16-.58c0-.22-.07-.45-.13-.68a2.63 2.63 0 00-.08 1.43 1.37 1.37 0 001.26.89 1.1 1.1 0 01.93.5 1.06 1.06 0 01.18.56c.05.23.07.46.13.68a2.38 2.38 0 00.05-1.39zm-18.74-3.28a1.39 1.39 0 00-1.29-.85 1.05 1.05 0 01-.9-.53 1.2 1.2 0 01-.16-.57c0-.23-.07-.46-.13-.69a2.67 2.67 0 00-.07 1.44 1.36 1.36 0 001.25.89 1.07 1.07 0 01.92.49 1 1 0 01.19.57c0 .23.07.45.13.68a2.46 2.46 0 00.06-1.39zm-11.86-22.69a1.32 1.32 0 00-.49-.61c0 .22 0 .46.05.71l.07.08a1.17 1.17 0 01.19.57c0 .23.07.46.13.68a2.46 2.46 0 00.05-1.39zm21.9 32.05a1.41 1.41 0 00-1.51.31 1.07 1.07 0 01-1 .26 1.09 1.09 0 01-.52-.29c-.19-.12-.37-.27-.58-.38a2.83 2.83 0 001 1.06 1.37 1.37 0 001.53-.27 1.06 1.06 0 011-.3 1.09 1.09 0 01.54.28c.19.12.37.26.57.38-.32-.33-.51-.78-1.03-1.01zm21.87 14h-.09a1.09 1.09 0 01-.52-.29c-.19-.13-.38-.27-.58-.38a2.82 2.82 0 001 1.06 1.36 1.36 0 00.44.11zm-12.95-2.75a1.38 1.38 0 00-.89 1.27 1.07 1.07 0 01-.49.92 1 1 0 01-.57.18c-.22.05-.45.07-.67.13a2.35 2.35 0 001.42.06 1.38 1.38 0 00.85-1.28 1.08 1.08 0 01.52-.9 1.17 1.17 0 01.58-.17c.23 0 .45-.07.68-.13a2.63 2.63 0 00-1.43 0zm-8.86-29.17a1.37 1.37 0 00-.89 1.26 1.08 1.08 0 01-.5.93 1.09 1.09 0 01-.56.18c-.23 0-.46.07-.68.13a2.38 2.38 0 001.43.05 1.38 1.38 0 00.85-1.28 1.05 1.05 0 01.52-.9 1.41 1.41 0 01.58-.17c.22 0 .45-.07.67-.13a2.69 2.69 0 00-1.42.01zM396 148.5a1.39 1.39 0 00-.89 1.27 1.06 1.06 0 01-.49.92 1.13 1.13 0 01-.57.18c-.22 0-.45.07-.68.14a2.47 2.47 0 001.43.05 1.39 1.39 0 00.85-1.29 1.07 1.07 0 01.52-.89 1.17 1.17 0 01.58-.17c.23 0 .46-.07.68-.13a2.63 2.63 0 00-1.43-.08z"
          style={{
            WebkitTransformOrigin: 407.275,
            MsTransformOrigin: 407.275,
            transformOrigin: 407.275,
          }}
          id="eltdw5ikicl2a"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          d="M401.05 181.55c-.53-1.2-1.08-2.38-1.65-3.55-1.11-2.27-2.22-4.54-3.29-6.83s-2.09-4.6-3.16-6.89-2.25-4.68-3.36-7h-.07c.68 1.72 1.36 3.45 2.06 5.17-.55-.87-1.08-1.74-1.59-2.63 0 0-.11 0-.08.05a33.24 33.24 0 002 3.4l.51 1.25c1 2.28 2 4.53 3 6.78s2.07 4.62 3.12 6.93c.54 1.19 1.11 2.36 1.7 3.52a12.38 12.38 0 001.89 3.15.08.08 0 00.13-.06 12.35 12.35 0 00-1.21-3.29z"
          style={{
            WebkitTransformOrigin: 395.889,
            MsTransformOrigin: 395.889,
            transformOrigin: 395.889,
          }}
          id="el6g0k8u7yv9j"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M431.45 200c-3.4 5.63-21.18 9.46-47.59 11.61-3.6.3-9.74-21.82-6.07-23 4.63-1.49 24.82-3.94 26.2-4.12 11.65-1.49 29.77 11.7 27.46 15.51z"
          style={{
            WebkitTransformOrigin: 404.156,
            MsTransformOrigin: 404.156,
            transformOrigin: 404.156,
          }}
          id="el32j85i0kjtx"
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M386.66 186.5l11.53 26.15s30.34-5.35 33.26-12.64-18.85-15.76-24.23-15.85-20.56 2.34-20.56 2.34z"
          style={{
            WebkitTransformOrigin: 409.189,
            MsTransformOrigin: 409.189,
            transformOrigin: 409.189,
          }}
          id="el990cv5awfh6"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M404.79 209.51c-.6-2-1.49-3.95-2.28-5.89s-1.58-3.82-2.39-5.72c-1.63-3.84-3.19-7.75-5.07-11.47a.07.07 0 00-.14 0c1.26 4 2.94 7.92 4.56 11.79.81 1.95 1.66 3.88 2.52 5.81a52.55 52.55 0 002.66 5.5c.05.14.17.06.14-.02z"
          style={{
            WebkitTransformOrigin: 399.852,
            MsTransformOrigin: 399.852,
            transformOrigin: 399.852,
          }}
          id="elk56isepkcm"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M418.53 187.65a44 44 0 00-5.71-2.52l-.86-.3a30.25 30.25 0 013.52.65c.09 0 .11-.1 0-.13a14.13 14.13 0 00-4.55-.83 13.86 13.86 0 00-4.08-.65c-2.14 0-4.29.29-6.41.48s-4.4.44-6.6.73c-2.42.32-4.82.67-7.21 1.2-.14 0-.1.26 0 .25 4.24-.32 8.46-.89 12.68-1.33q3.12-.33 6.24-.58a11.64 11.64 0 013.12 0 23.83 23.83 0 012.9.78c1.09.34 2.2.65 3.29 1s2.36.9 3.52 1.37c.17.08.26-.06.15-.12z"
          style={{
            WebkitTransformOrigin: 402.559,
            MsTransformOrigin: 402.559,
            transformOrigin: 402.559,
          }}
          id="elzmrzig5nrbd"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M423.38 198.26a1.38 1.38 0 00-1.28-.84 1.09 1.09 0 01-.9-.53 1.11 1.11 0 01-.17-.58c0-.22-.07-.45-.13-.67a2.72 2.72 0 00-.08 1.43 1.37 1.37 0 001.27.88 1.12 1.12 0 01.93.5 1.1 1.1 0 01.17.57c.06.22.08.44.13.67a2.38 2.38 0 00.06-1.43zM402.17 188a1.38 1.38 0 00-1.28-.84 1.06 1.06 0 01-.89-.52 1.28 1.28 0 01-.18-.58 5.79 5.79 0 00-.13-.68 2.73 2.73 0 00-.07 1.43 1.35 1.35 0 001.27.88 1.11 1.11 0 01.92.51 1.06 1.06 0 01.18.56c.05.23.07.45.13.68a2.41 2.41 0 00.05-1.44zm-9.46 6.9a1.36 1.36 0 00-1.5.31 1.05 1.05 0 01-.59.28l.2.47a1.31 1.31 0 00.74-.37 1.11 1.11 0 011-.3 1.14 1.14 0 01.53.26c.2.14.37.28.58.4-.25-.39-.44-.84-.96-1.06zm35.38 7.82c.11.16.21.32.33.48a1.15 1.15 0 00.19-.14zm-19.9-4.25a1.44 1.44 0 00-1.51.32 1.06 1.06 0 01-1 .26 1 1 0 01-.53-.29c-.19-.12-.37-.27-.57-.38a2.65 2.65 0 00.95 1.06 1.38 1.38 0 001.53-.26 1 1 0 011-.3 1 1 0 01.53.27c.19.12.36.27.57.38a2.51 2.51 0 00-.97-1.07zm8.14 7a1.36 1.36 0 00-.89 1.26 1.07 1.07 0 01-.49.92 1.14 1.14 0 01-.57.19c-.22 0-.45.07-.67.13a2.51 2.51 0 001.42.06 1.41 1.41 0 00.85-1.29 1.08 1.08 0 01.52-.9 1.17 1.17 0 01.58-.17c.23 0 .45-.07.68-.13a2.73 2.73 0 00-1.43-.08zm-.39-19a1.39 1.39 0 00-.5 1 1.07 1.07 0 01-.49.92 1 1 0 01-.57.18c-.22.05-.45.07-.67.13a2.35 2.35 0 001.42.06 1.38 1.38 0 00.85-1.28 1.06 1.06 0 01.46-.86z"
          style={{
            WebkitTransformOrigin: 409.615,
            MsTransformOrigin: 409.615,
            transformOrigin: 409.615,
          }}
          id="elp66py6b1gi"
          fill="#FFF"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 397.23,
            MsTransformOrigin: 397.23,
            transformOrigin: 397.23,
          }}
          id="el3rv82fu4vi5"
          fill="#455A64"
          d="M374.1 203.6H420.36V206.29999999999998H374.1z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 388.16,
            MsTransformOrigin: 388.16,
            transformOrigin: 388.16,
          }}
          id="ellarl1xbuwi"
          fill="#263238"
          d="M374.1 203.6H402.22V206.29999999999998H374.1z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 363.895,
            MsTransformOrigin: 363.895,
            transformOrigin: 363.895,
          }}
          id="el94q22co0onu"
          fill="#455A64"
          d="M397.36 206.34L338.81 206.35 330.43 166.38 388.99 166.38 397.36 206.34z"
          className="animable"
        ></path>
        <path
          d="M367.46 186.36a3.15 3.15 0 01-3.19 3.58 4.06 4.06 0 01-3.94-3.58 3.15 3.15 0 013.19-3.58 4.06 4.06 0 013.94 3.58z"
          style={{
            WebkitTransformOrigin: 363.895,
            MsTransformOrigin: 363.895,
            transformOrigin: 363.895,
          }}
          id="elgxlpt84yrf6"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M387.57 208.72c-3.61 2-8 6.63-11 7.16a3.51 3.51 0 01-3.8-1.75s-1.35 3.1-4.16 3.12c-1.45 0-2.74-2.28-2.74-2.28a4.17 4.17 0 01-3.69 2.3c-2-.1-3-2.39-3-2.39s-2.23 1.81-4.23 1.05c-4-1.54-5-18.63 1.21-21.61 2.87-1.38 2.87 2.8 2.87 2.8s1.46-6 5-6.29 3.19 5.16 3.19 5.16 1.47-5.82 5.14-5.74c3.83.09 2.56 5.47 2.56 5.47s2.38-3.93 5.18-3.23c4.63 1.17-.62 10.1.47 13.81h6.12z"
          style={{
            WebkitTransformOrigin: 369.648,
            MsTransformOrigin: 369.648,
            transformOrigin: 369.648,
          }}
          id="eljgi5ab7yc"
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M382.37 212.06c3.58-1.55 5.29 1 9 .52 4.15-.54 2.8-5.42-4.5-6.28h-6.33z"
          style={{
            WebkitTransformOrigin: 387.117,
            MsTransformOrigin: 387.117,
            transformOrigin: 387.117,
          }}
          id="el4sez6rs5nrk"
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M359 214.54c0 .06-.07.08-.09 0a29.63 29.63 0 01.09-17.64c.06-.19.39-.16.35 0a60.65 60.65 0 00-.35 17.64z"
          style={{
            WebkitTransformOrigin: 358.482,
            MsTransformOrigin: 358.482,
            transformOrigin: 358.482,
          }}
          id="elq4jj8c5e45"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M365.85 215.05c0 .07-.1.08-.12 0a27.8 27.8 0 011.33-19.27c.1-.21.4-.3.3-.05-1.66 4.27-2.27 13.84-1.51 19.32z"
          style={{
            WebkitTransformOrigin: 365.991,
            MsTransformOrigin: 365.991,
            transformOrigin: 365.991,
          }}
          id="el2hk20l6r4iq"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M375.29 195.35c-2.61 5.94-3.05 12.13-2.59 18.55 0 .08-.12.08-.14 0-1.08-3.08-.95-7.2-.57-10.4a17.14 17.14 0 013.09-8.25c.07-.09.26-.03.21.1z"
          style={{
            WebkitTransformOrigin: 373.506,
            MsTransformOrigin: 373.506,
            transformOrigin: 373.506,
          }}
          id="elhk2sw4dgcb9"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M384.64 140.3c-.3 1-5.4 7-9.87 6.52-1.46-.17-.9-8.16-.9-8.16l-.09-.6-1.3-8.38 10.13-5.59 1.45-.73s.21 2.32.43 5.21v.41c0 .17 0 .32.05.47 0 .43.08.87.1 1.31s.05.66.06 1 0 .7.06 1a54.24 54.24 0 01-.12 7.54z"
          style={{
            WebkitTransformOrigin: 378.659,
            MsTransformOrigin: 378.659,
            transformOrigin: 378.659,
          }}
          id="elydpy4q1qims"
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M384.49 128.57a17 17 0 01-10.71 9.49l-1.3-8.38 10.13-5.59 1.45-.73s.21 2.32.43 5.21z"
          style={{
            WebkitTransformOrigin: 378.485,
            MsTransformOrigin: 378.485,
            transformOrigin: 378.485,
          }}
          id="elj7qzy7xpo2"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M361.15 119c.85 14.87 9.86 16 13.06 15.85 2.91-.17 12.8-1.12 13.49-16s-6.5-19.18-13.18-19.15-14.23 4.45-13.37 19.3z"
          style={{
            WebkitTransformOrigin: 374.414,
            MsTransformOrigin: 374.414,
            transformOrigin: 374.414,
          }}
          id="el51osnjmzu0t"
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M363.69 114.78c.35-.06.66-.18 1-.27a1.71 1.71 0 001-.47.54.54 0 000-.65 1.31 1.31 0 00-1.31-.23 1.92 1.92 0 00-1.17.75.56.56 0 00.48.87z"
          style={{
            WebkitTransformOrigin: 364.458,
            MsTransformOrigin: 364.458,
            transformOrigin: 364.458,
          }}
          id="elz4yd31ihx5o"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M373.79 114.59c-.35 0-.67-.1-1-.16a1.6 1.6 0 01-1-.36.53.53 0 010-.64 1.29 1.29 0 011.27-.38 1.89 1.89 0 011.25.61.57.57 0 01-.52.93z"
          style={{
            WebkitTransformOrigin: 373.063,
            MsTransformOrigin: 373.063,
            transformOrigin: 373.063,
          }}
          id="eljq6jcyrtaa"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M371.5 118.41s.08 0 .08.09c0 1 .17 2.17 1.1 2.48v.06c-1.13-.12-1.35-1.67-1.18-2.63z"
          style={{
            WebkitTransformOrigin: 372.064,
            MsTransformOrigin: 372.064,
            transformOrigin: 372.064,
          }}
          id="eldnzbrby0s4"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M372.37 117.32c1.62-.18 1.86 3.09.35 3.25s-1.72-3.1-.35-3.25z"
          style={{
            WebkitTransformOrigin: 372.592,
            MsTransformOrigin: 372.592,
            transformOrigin: 372.592,
          }}
          id="elx1roiv411r"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M373 117.45c.3.16.6.47 1 .48s.67-.36.91-.7h.06c.05.62-.14 1.28-.8 1.43s-1.09-.4-1.29-1c-.07-.1.02-.28.12-.21z"
          style={{
            WebkitTransformOrigin: 373.916,
            MsTransformOrigin: 373.916,
            transformOrigin: 373.916,
          }}
          id="elu80jusj8x9"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M365.86 118.37s-.07.06-.07.1c.12 1 .08 2.18-.81 2.59 0 0 0 .06 0 0 1.11-.19 1.15-1.75.88-2.69z"
          style={{
            WebkitTransformOrigin: 365.49,
            MsTransformOrigin: 365.49,
            transformOrigin: 365.49,
          }}
          id="elbd1o77al10p"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M364.88 117.39c-1.64 0-1.51 3.28 0 3.27s1.37-3.28 0-3.27z"
          style={{
            WebkitTransformOrigin: 364.829,
            MsTransformOrigin: 364.829,
            transformOrigin: 364.829,
          }}
          id="elt7166jid92d"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M364.2 117.63c-.25.19-.49.51-.8.54s-.64-.3-.88-.63c0 .62.24 1.27.85 1.36s.93-.46 1.06-1.09c-.03-.08-.13-.25-.23-.18z"
          style={{
            WebkitTransformOrigin: 363.475,
            MsTransformOrigin: 363.475,
            transformOrigin: 363.475,
          }}
          id="elog54roge0t"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M371.87 126.58c-.21.27-.41.62-.77.7a2.68 2.68 0 01-1.12-.13v.06a1.36 1.36 0 001.34.39 1.08 1.08 0 00.69-1c-.01-.04-.11-.05-.14-.02z"
          style={{
            WebkitTransformOrigin: 370.995,
            MsTransformOrigin: 370.995,
            transformOrigin: 370.995,
          }}
          id="el46gefb19pqv"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M367.42 123.18s-.12 1.53-.08 2.24c0 .07.18.09.43.09A3.4 3.4 0 00371 124c.05-.07-.05-.14-.11-.09a5.13 5.13 0 01-3 1.07c-.07-.19.28-2.6.17-2.6a6.42 6.42 0 00-1.6.46c.15-3.18.82-6.32.92-9.49a.1.1 0 00-.19 0 51.78 51.78 0 00-1.42 10.18c-.07.41 1.37-.21 1.65-.35z"
          style={{
            WebkitTransformOrigin: 368.391,
            MsTransformOrigin: 368.391,
            transformOrigin: 368.391,
          }}
          id="elo41k9j9mf5m"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M368.22 125.3a3.81 3.81 0 001.6 1.06 1.76 1.76 0 001 0c.74-.25.7-.94.52-1.52a3.8 3.8 0 00-.4-.87 5 5 0 01-2.72 1.33z"
          style={{
            WebkitTransformOrigin: 369.835,
            MsTransformOrigin: 369.835,
            transformOrigin: 369.835,
          }}
          id="el254ohkyhmx3"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M369.82 126.36a1.76 1.76 0 001 0c.74-.25.7-.94.52-1.52a1.77 1.77 0 00-1.52 1.52z"
          style={{
            WebkitTransformOrigin: 370.635,
            MsTransformOrigin: 370.635,
            transformOrigin: 370.635,
          }}
          id="elj4a1pdplhm"
          fill="#FF9CBD"
          className="animable"
        ></path>
        <path
          d="M386.82 119.22c-1.63 0-6.11-4.25-6.67-12.1 0 0 1 7 1.58 8s-2.51-2.39-3.05-8.71a25.71 25.71 0 01-6.31 3.72c-2.95 1-4.78 1.08-5 .87s4.1-1.83 5.22-3.27c0 0-7.76 4.14-11.41 4.62-.42.06-1.41-8.64 4.06-12.65s14.67-.51 17.21 1.69c0 0 2.86.24 6.17 4.27s-.04 13.56-1.8 13.56z"
          style={{
            WebkitTransformOrigin: 375.427,
            MsTransformOrigin: 375.427,
            transformOrigin: 375.427,
          }}
          id="elqj0n0mqa2yp"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M385.4 120.15s2.55-5.07 4.81-4.23.8 7.87-1.52 9.14a2.51 2.51 0 01-3.53-.86z"
          style={{
            WebkitTransformOrigin: 388.249,
            MsTransformOrigin: 388.249,
            transformOrigin: 388.249,
          }}
          id="el3m1bperhq2m"
          fill="#EB9481"
          className="animable"
        ></path>
        <path
          d="M389.74 117.93v.06a6.38 6.38 0 00-2.68 4.42 1.39 1.39 0 012-.68.05.05 0 010 .1 1.55 1.55 0 00-1.61.78 7.33 7.33 0 00-.61 1.48c-.06.17-.35.12-.32-.06-.36-2.23.9-5.54 3.22-6.1z"
          style={{
            WebkitTransformOrigin: 388.1,
            MsTransformOrigin: 388.1,
            transformOrigin: 388.1,
          }}
          id="ela5lsln2tmgd"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M373.86 138.57l3.08 6.59 7.91-9 2.53 2.61s-7.45 14-7.54 13.41l-3.1-5.67-3.74 4.27-.24-10.17z"
          style={{
            WebkitTransformOrigin: 380.07,
            MsTransformOrigin: 380.07,
            transformOrigin: 380.07,
          }}
          id="elu715ng3klil"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M372.55 145.76c0-1.68 0-3.38.08-5 0-.06.1-.1.11 0 .43 1.6.33 8 .42 9.57.16-.19 3.52-3.77 3.56-3.72.65.89 2.93 5 3.09 5.39 1.18-2.22 6.21-11 7.63-13.14 0-.06.14 0 .11.05-1 2.34-7.52 13.94-7.62 13.92a66.33 66.33 0 01-3.24-6c-.57.77-3.94 4.79-4 4.54a53.59 53.59 0 01-.14-5.61z"
          style={{
            WebkitTransformOrigin: 380.042,
            MsTransformOrigin: 380.042,
            transformOrigin: 380.042,
          }}
          id="elwdzf1nqzhke"
          fill="#263238"
          className="animable"
        ></path>
      </g>
      <g
        id="freepik--Cloud--inject-32"
        className="animable animator-active animator-hidden"
        style={{
          WebkitTransformOrigin: 250,
          MsTransformOrigin: 250,
          transformOrigin: 250,
        }}
      >
        <path
          d="M198.35 112a13.31 13.31 0 0012.32 13.27H286a15.64 15.64 0 001.46-31.21 26.34 26.34 0 00-51.05-8.24 15.64 15.64 0 00-22.6 13 12.85 12.85 0 00-2.16-.18 13.31 13.31 0 00-13.3 13.36z"
          style={{
            WebkitTransformOrigin: 249.986,
            MsTransformOrigin: 249.986,
            transformOrigin: 249.986,
          }}
          id="elm4q24nsmbk"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 250,
            MsTransformOrigin: 250,
            transformOrigin: 250,
          }}
          id="elh4va3hsgqfm"
          fill="#FFF"
          d="M243.2 102.54H256.8V114.21000000000001H243.2z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 250,
            MsTransformOrigin: 250,
            transformOrigin: 250,
          }}
          id="elti935zihsfg"
          fill="#FFF"
          d="M238.53 102.54L261.47 102.54 250 91.1 238.53 102.54z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 317.44,
            MsTransformOrigin: 317.44,
            transformOrigin: 317.44,
          }}
          id="elze8o24x2kgd"
          fill="#263238"
          d="M316.44 113.43H318.44V114.43H316.44z"
          className="animable"
        ></path>
        <path
          d="M332 114.43h-3.89v-1H332zm-6.8 0h-3.88v-1h3.88z"
          style={{
            WebkitTransformOrigin: 326.66,
            MsTransformOrigin: 326.66,
            transformOrigin: 326.66,
          }}
          id="eljhxvrtrmmyh"
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 336.2,
            MsTransformOrigin: 336.2,
            transformOrigin: 336.2,
          }}
          id="el6hz03tor42j"
          fill="#263238"
          d="M337.45 115.93L336.45 115.93 336.45 114.43 334.95 114.43 334.95 113.43 337.45 113.43 337.45 115.93z"
          className="animable"
        ></path>
        <path
          d="M337.45 155.62h-1v-3.78h1zm0-6.61h-1v-3.78h1zm0-6.62h-1v-3.78h1zm0-6.61h-1V132h1zm0-6.62h-1v-3.78h1zm0-6.62h-1v-3.78h1z"
          style={{
            WebkitTransformOrigin: 336.95,
            MsTransformOrigin: 336.95,
            transformOrigin: 336.95,
          }}
          id="el0hlqjr9yz2d7"
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 336.95,
            MsTransformOrigin: 336.95,
            transformOrigin: 336.95,
          }}
          id="elxou8ztxaaj"
          fill="#263238"
          d="M336.45 158.46H337.45V160.46H336.45z"
          className="animable"
        ></path>
        <path
          d="M316.54 115.81a1.88 1.88 0 111.88-1.88 1.88 1.88 0 01-1.88 1.88z"
          style={{
            WebkitTransformOrigin: 316.54,
            MsTransformOrigin: 316.54,
            transformOrigin: 316.54,
          }}
          id="elvp4i84ege8j"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M335.07 160.36a1.88 1.88 0 101.88-1.88 1.88 1.88 0 00-1.88 1.88z"
          style={{
            WebkitTransformOrigin: 336.95,
            MsTransformOrigin: 336.95,
            transformOrigin: 336.95,
          }}
          id="el1wchwod5qdz"
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 182.56,
            MsTransformOrigin: 182.56,
            transformOrigin: 182.56,
          }}
          id="elum8rtm18kg"
          fill="#263238"
          d="M181.56 113.43H183.56V114.43H181.56z"
          className="animable"
        ></path>
        <path
          d="M178.64 114.43h-3.88v-1h3.88zm-6.79 0H168v-1h3.89z"
          style={{
            WebkitTransformOrigin: 173.32,
            MsTransformOrigin: 173.32,
            transformOrigin: 173.32,
          }}
          id="el49gxhn20w5v"
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 163.8,
            MsTransformOrigin: 163.8,
            transformOrigin: 163.8,
          }}
          id="el0gk1yeg4eeh"
          fill="#263238"
          d="M163.55 115.93L162.55 115.93 162.55 113.43 165.05 113.43 165.05 114.43 163.55 114.43 163.55 115.93z"
          className="animable"
        ></path>
        <path
          d="M163.55 155.62h-1v-3.78h1zm0-6.61h-1v-3.78h1zm0-6.62h-1v-3.78h1zm0-6.61h-1V132h1zm0-6.62h-1v-3.78h1zm0-6.62h-1v-3.78h1z"
          style={{
            WebkitTransformOrigin: 163.05,
            MsTransformOrigin: 163.05,
            transformOrigin: 163.05,
          }}
          id="elkb048lejjo7"
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 163.05,
            MsTransformOrigin: 163.05,
            transformOrigin: 163.05,
          }}
          id="el5axzg8ffoh6"
          fill="#263238"
          d="M162.55 158.46H163.55V160.46H162.55z"
          className="animable"
        ></path>
        <circle
          cx="183.46"
          cy="113.93"
          r="1.88"
          style={{
            WebkitTransformOrigin: 183.46,
            MsTransformOrigin: 183.46,
            transformOrigin: 183.46,
          }}
          id="eltu30p1a1l6r"
          fill="#263238"
          className="animable"
        ></circle>
        <path
          d="M161.17 160.36a1.88 1.88 0 101.88-1.88 1.88 1.88 0 00-1.88 1.88z"
          style={{
            WebkitTransformOrigin: 163.05,
            MsTransformOrigin: 163.05,
            transformOrigin: 163.05,
          }}
          id="eld7v7q147tj"
          fill="#263238"
          className="animable"
        ></path>
      </g>
      <g
        id="freepik--Plant--inject-32"
        className="animable"
        style={{
          WebkitTransformOrigin: 77.3806,
          MsTransformOrigin: 77.3806,
          transformOrigin: 77.3806,
        }}
      >
        <path
          d="M69 337.93a76.74 76.74 0 011.77-12.43 27.54 27.54 0 014.45-10.5 13.32 13.32 0 018.7-5.43c3.41-.41 6.61 1.11 9.16 3.25 3.16 2.67 5.58 6.19 7.86 9.6a118 118 0 016.78 11.87c.07.14-.14.25-.21.12a73.7 73.7 0 00-6.06-9.94 62.86 62.86 0 00-7-8.45c-2.34-2.28-5.31-4.42-8.7-4.53a10.7 10.7 0 00-8.52 4.39C75 318.8 73.81 322.44 73 326a75.15 75.15 0 00-1.75 11.84c-.67 8.19-.85 16.42-1 24.63-.11 4.65-.17 9.3-.21 13.94l-.06 7.07a44.19 44.19 0 01-.27 6.81c-.08.45-.83.41-.9 0a39.84 39.84 0 01-.32-6.46q0-3.34-.08-6.69c0-4.34-.06-8.68 0-13-.1-8.78.01-17.52.59-26.21z"
          style={{
            WebkitTransformOrigin: 88.0556,
            MsTransformOrigin: 88.0556,
            transformOrigin: 88.0556,
          }}
          id="elc28ib2kdix4"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M80.71 331.76c.43-2.32 1.22-5.33 2.54-7.13 2.37-3.22 4.93-1.82 2.56 1.75a21.4 21.4 0 00-3.33 8.8s4 5.69 8.8 8.5c-.21-2.19-.83-5.56-.4-8.81.92-7 5.18-6.63 4.13-1.05a48.16 48.16 0 00-1 11.3 23.75 23.75 0 005.14 2.52c-.27-.81-.57-1.79-.89-3-1.71-6.3 2.5-8.27 2.63-4.72a48.91 48.91 0 001.64 8.94c2.3.77 4.21 1.3 5.38 1.71a19.74 19.74 0 017.89 5.39 25 25 0 005.37-7c-1.47-1.26-3.79-3.14-7-5.42-6-4.27-4-9.66.85-6.31 3.46 2.42 6.14 6.9 7.36 9.2a37.62 37.62 0 002.74-12.58c-4.75-4.46-16.49-10.67-13-10.67 3.18 0 10.31 4.67 12.92 6.47a32.78 32.78 0 00-.4-3.66c-4.47-2.93-19-7.49-16.69-8.8 2.55-1.44 12.68 3.26 15.75 4.74a18.22 18.22 0 00-2.69-5.56c-6.17-8.27-17.32-11.12-22.18-9.55-3.44 1.12-2.43 9.85-3.17 9.55-13.75-5.49-20.03-1.56-14.95 15.39zm33.87-1c1-1.18 5.52 2.3 4.2 4.21s-5.46-2.65-4.2-4.17zm-23.69-7.44c1.19.76-.57 5.17-2.41 3.83-1.57-1.1 1.21-4.56 2.41-3.79z"
          style={{
            WebkitTransformOrigin: 102.04,
            MsTransformOrigin: 102.04,
            transformOrigin: 102.04,
          }}
          id="elii1rowwo1x"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M92.7 324.71c.62-1.23 1.27-2.46 2-3.64a21.6 21.6 0 012.3-3.31c-.19-.25-.38-.49-.59-.73a.1.1 0 01.15-.14c.23.27.45.54.68.8a.27.27 0 01.09.12c.86 1 1.66 2.07 2.43 3.15a37.45 37.45 0 014 1.16c1.36.46 2.7.93 4 1.48.13.06.06.29-.07.23-1.31-.58-2.63-1.14-4-1.6s-2.58-.76-3.88-1.13c.42.6.83 1.2 1.23 1.81a47.59 47.59 0 017.1 2.89c2.4 1.14 4.7 2.47 7 3.79a.12.12 0 01-.12.2 77.75 77.75 0 00-7-3.6c-2.22-1-4.52-1.9-6.76-2.89 5.64 8.81 9 19 13.55 28.38.07.13-.15.25-.2.11-1.39-3.3-3-6.52-4.48-9.76-1.35-2.91-2.67-5.84-4-8.76-.4-.85-.8-1.7-1.22-2.55.25 4.7.15 9.49.92 14.14a.12.12 0 11-.23 0c-.33-5-1.21-10-1.18-15v-.06c-1-1.92-2-3.82-3.08-5.66-1.87 4.4-3.83 8.87-4.71 13.59 0 .15-.26.08-.22-.06 1.27-4.74 2.45-9.49 4.73-13.86a51.69 51.69 0 00-4-5.73c-.63 1.17-1.43 2.27-2.15 3.39s-1.38 2.19-2 3.32a47.54 47.54 0 00-3.53 7.46c0 .14-.28.07-.22-.07 1.13-2.52 2.22-5.04 3.46-7.47z"
          style={{
            WebkitTransformOrigin: 102.204,
            MsTransformOrigin: 102.204,
            transformOrigin: 102.204,
          }}
          id="eld04ue60uctk"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M48.22 335.42c3.62-3.63 7.83-8.4 13.42-8.39 5.4 0 9.38 4.36 11.66 8.84 2.39 4.69 3.25 10 3.92 15.17a182 182 0 011.43 18.66c.1 3.46.09 6.93 0 10.39a68.13 68.13 0 01-.79 10.49c-.1.56-1 .58-1 0-.16-2.91 0-5.84 0-8.76s0-5.75-.14-8.62c-.21-5.81-.63-11.62-1.31-17.39-.6-5-1.07-10.23-2.58-15.11-1.36-4.39-3.92-9.42-8.37-11.35-6.08-2.63-12 2.18-16 6.25-.17.07-.35-.08-.24-.18z"
          style={{
            WebkitTransformOrigin: 63.4538,
            MsTransformOrigin: 63.4538,
            transformOrigin: 63.4538,
          }}
          id="elvcz6uxj3shp"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M29.74 343.53c0 .74.08 1.48.13 2.19a13.15 13.15 0 015.93-2.46c5.14-.54 4.81 3.37 1.38 3.53a19.61 19.61 0 00-7 1.41c.83 6.79 2.7 12.24 3 12.32a100.93 100.93 0 0013.58-1.72c-1.28-2.72-4.19-6.34-2.71-6.63s3.11 2.93 3.93 6.38a63.27 63.27 0 009.88-2.72c-2.26-1.95-5.76-4.39-4.42-5.42s4.11 2.39 5.77 4.88a20.6 20.6 0 004.27-2.38c-3-4.47-10.47-5.39-9.5-8.62s7.91 1.25 11 7.24c3.66-3.8 4.73-9.17 4.35-13.76-3.19-.37-9.33.3-8.89-2s4.88-1.86 8.51-.52a12.62 12.62 0 00-2.13-5c-3.36-4.31-13.62 1.17-13.62 1.17s1.1-10.31-2.81-12.09c-2.26-1-6.24-1-10.23 1.34 2.24.18 5 .89 6 2.44 1.4 2-.8 3.06-2.2 2.15-1-.65-2.81-2.69-6.12-3a22 22 0 00-4.84 5.82 14.1 14.1 0 0112 .21c4.45 2.21 2 6.83-1.86 5s-7.47-3.56-11.53-2.55a28.77 28.77 0 00-1.95 11.5 20.23 20.23 0 016.59-3.16c4.42-1.16 5.75 1.48.9 2a19.51 19.51 0 00-7.41 2.45zm5.38-7.1c-.3-1.43 2.83-1.84 3.36-.68.43.99-3.06 2.12-3.36.68zM62 344.37c.3-.78 2.4.1 2.21 1.08-.32 1.3-2.54-.3-2.21-1.08zm-14.81 5c1.53-.61 3.92 3.19 2.25 4.06s-3.55-3.53-2.3-4.04z"
          style={{
            WebkitTransformOrigin: 49.5217,
            MsTransformOrigin: 49.5217,
            transformOrigin: 49.5217,
          }}
          id="elvk6xa5hz9i"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M33.71 359.74c2.3-3.85 4.58-7.72 7-11.5 1.13-1.77 2.31-3.49 3.53-5.19-.18 0-.36-.09-.54-.13l-.92-.17c-.71-.13-1.42-.23-2.14-.3a19.38 19.38 0 00-2-.11 9.76 9.76 0 00-2.16.11c-.09 0-.1-.12 0-.11.72 0 1.46-.07 2.18-.08s1.4 0 2.1.05 1.31.1 2 .2l1.07.19a5 5 0 01.65.14q1.88-2.58 3.88-5a46.39 46.39 0 00-12.61-4c-.08 0-.05-.13 0-.12a43 43 0 0112.79 3.88l2.23-2.7c.83-1 1.72-2 2.48-3a.06.06 0 11.09.07 42.63 42.63 0 00-2.93 3.58 44.47 44.47 0 014.69 3.77c1.53 1.36 3 2.76 4.48 4.2 0 .06 0 .14-.08.09-1.44-1.43-2.93-2.79-4.49-4.09s-3.19-2.48-4.76-3.76l-1.1 1.24c-.19.23-.36.47-.55.71v.05l-1.79 2.34a19.4 19.4 0 011.78 3.22c.51 1.09 1 2.21 1.38 3.34a49.87 49.87 0 011.92 7.22c0 .07-.1.11-.11 0a43.61 43.61 0 00-2.1-7.08c-.45-1.17-1-2.32-1.49-3.47s-1-2-1.5-3.1c-.52.69-1 1.38-1.54 2.08-.15.2-.29.4-.43.61v.1c-1.58 2.21-3.09 4.48-4.55 6.76a2.08 2.08 0 01.2.51c.09.27.18.55.26.84a16.37 16.37 0 01.41 1.71c.09.54.17 1.09.22 1.64a16.45 16.45 0 00.14 1.87c0 .09-.13.09-.11 0a6 6 0 00-.13-1.74 17.26 17.26 0 00-.33-1.77c-.12-.53-.27-1.06-.42-1.58-.08-.26-.17-.52-.26-.78s-.11-.28-.16-.42a108.5 108.5 0 00-2 3.24c-1.33 2.15-2.64 4.31-4 6.47-.17.23-.35.08-.28-.03z"
          style={{
            WebkitTransformOrigin: 46.6372,
            MsTransformOrigin: 46.6372,
            transformOrigin: 46.6372,
          }}
          id="elqaw2su271hb"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M69.25 389.33c.06-2.18.41-4.38.64-6.55s.49-4.36.72-6.54a99 99 0 011.69-12.63 18.34 18.34 0 015.13-9.44 8.4 8.4 0 015-2.41 8.72 8.72 0 015.35 1.65 18.62 18.62 0 014.5 4.74 46.88 46.88 0 013.51 5.7c0 .07-.08.12-.12 0a29.42 29.42 0 00-7.59-8.51 9 9 0 00-4.79-2 6.46 6.46 0 00-4.63 1.85c-2.55 2.21-4 5.47-4.9 8.67a88.26 88.26 0 00-1.9 11.66c-.31 2.31-.6 4.62-.91 6.93s-.49 4.66-1 6.93a.38.38 0 01-.7-.05z"
          style={{
            WebkitTransformOrigin: 82.52,
            MsTransformOrigin: 82.52,
            transformOrigin: 82.52,
          }}
          id="eli8a1o7rxehc"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M80 372.38a12.63 12.63 0 002.38 2.42c-.36-2.13-.8-5.92.28-7.93 1.67-3.13 3.65-1.57 2.65 1.15a22.37 22.37 0 00-1.61 7.72 33.69 33.69 0 007.3 3.42 12 12 0 01-.24-3.74c.33-3.34 2.89-3.28 2.23.2a21 21 0 00-.35 4.09 75.7 75.7 0 0011.3 2.55 33 33 0 004.68-8.33c-2.72-.68-8.24-.84-8.12-2.78.16-2.62 5.5-.61 8.62 1.29a20.92 20.92 0 001-7 35.14 35.14 0 00-7.51-1.25c-5.61-.48-5.34-3.66-1.27-3.59 3 .06 6.79 1.89 8.59 2.85-1.17-7.63-7-12.52-11.66-12.71-7.84-.32-5 9.45-5 9.45s-5.32-3.74-10.33-3.64-8.31 8.36-2.94 15.83zm21-14.12c-.17-1.1 3.33-1.36 3.51.05.15 1.58-3.39 1.07-3.57-.05zm5.64 11.46c-.08-.72 1.44-.85 1.78.06.17.58-1.78.64-1.84-.06zm-18.84.66c1.18.17 1.85 4.4-.18 4.31-1.62-.06-.88-4.45.12-4.31z"
          style={{
            WebkitTransformOrigin: 93.6873,
            MsTransformOrigin: 93.6873,
            transformOrigin: 93.6873,
          }}
          id="elcylg46tbgnc"
          fill="#000A18"
          className="animable"
        ></path>
        <path
          d="M89.38 375.08c.19-.53.37-1.06.53-1.6-.15.54-.29 1.09-.39 1.64a.07.07 0 11-.14-.04z"
          style={{
            WebkitTransformOrigin: 89.6436,
            MsTransformOrigin: 89.6436,
            transformOrigin: 89.6436,
          }}
          id="el9td98wkut7j"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M91.45 368.28c.37-1.08.78-2.15 1.2-3.21.22-.57.46-1.14.71-1.69a7.17 7.17 0 01.69-1.42 11.19 11.19 0 01-.63-1.37h.07a16.81 16.81 0 011.51 2.33c.22.37.42.75.64 1.12a9.78 9.78 0 011.32.2c.47.09.94.18 1.4.29l1.4.32a13.41 13.41 0 001.39.34.08.08 0 110 .15 9.25 9.25 0 00-1.46-.39c-.45-.09-.91-.17-1.36-.24l-1.37-.17-1-.08c.19.33.38.65.56 1l.09.15a4.3 4.3 0 011.12.14c.41.07.81.15 1.21.24.82.18 1.64.37 2.45.6 1.69.47 3.37 1 5 1.56.1 0 0 .17-.05.14a49.63 49.63 0 00-5.08-1.41l-2.41-.53-1.2-.26a7.12 7.12 0 01-.94-.2c.86 1.59 1.68 3.21 2.42 4.86 1.63 3.6 3 7.31 4.39 11a.08.08 0 01-.14.06 99.59 99.59 0 00-4.67-10.76c-.31-.64-.64-1.27-1-1.91l-.09.39c-.08.44-.15.87-.23 1.31-.14.88-.29 1.75-.42 2.63a30.36 30.36 0 00-.64 5.45.08.08 0 11-.15 0c.14-.87.14-1.78.2-2.66s.12-1.83.23-2.75.21-1.76.36-2.63c.07-.44.15-.88.23-1.31a2.52 2.52 0 01.25-.95l-1.38-2.77c-.44-.86-.88-1.72-1.33-2.57-.19-.37-.39-.73-.6-1.1a9.27 9.27 0 01-.52 1.32l-.6 1.48c-.45 1.1-.87 2.2-1.29 3.31-.59 1.57-1.25 3.18-1.73 4.81.5-1.6.91-3.23 1.45-4.82z"
          style={{
            WebkitTransformOrigin: 98.2164,
            MsTransformOrigin: 98.2164,
            transformOrigin: 98.2164,
          }}
          id="els7izdzuc6sk"
          fill="#263238"
          className="animable"
        ></path>
        <path
          d="M89.91 373.48l.12-.38z"
          style={{
            WebkitTransformOrigin: 89.97,
            MsTransformOrigin: 89.97,
            transformOrigin: 89.97,
          }}
          id="elk5hyhf449kg"
          fill="#263238"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 73.63,
            MsTransformOrigin: 73.63,
            transformOrigin: 73.63,
          }}
          id="elpnn6pedoa6"
          fill="#37474F"
          d="M56.13 385.09L56.69 396.76 58.11 426.86 89.16 426.86 90.58 396.76 91.13 385.09 56.13 385.09z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 73.63,
            MsTransformOrigin: 73.63,
            transformOrigin: 73.63,
          }}
          id="el31k8zh4olhp"
          fill="#263238"
          d="M56.13 385.09L56.69 396.76 90.58 396.76 91.13 385.09 56.13 385.09z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 73.635,
            MsTransformOrigin: 73.635,
            transformOrigin: 73.635,
          }}
          id="elrrtjy354nkg"
          fill="#37474F"
          d="M53.93 380.36H93.34V389.8H53.93z"
          className="animable"
          transform="rotate(180)"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 83.915,
            MsTransformOrigin: 83.915,
            transformOrigin: 83.915,
          }}
          id="elzbspgfv86x"
          fill="#37474F"
          d="M81.19 426.86H86.64V431.8H81.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 83.915,
            MsTransformOrigin: 83.915,
            transformOrigin: 83.915,
          }}
          id="el4cq7bhl3v3a"
          fill="#263238"
          d="M81.19 426.86H86.64V429.33000000000004H81.19z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 63.345,
            MsTransformOrigin: 63.345,
            transformOrigin: 63.345,
          }}
          id="elndxv537efre"
          fill="#37474F"
          d="M60.62 426.86H66.07V431.8H60.62z"
          className="animable"
        ></path>
        <path
          style={{
            WebkitTransformOrigin: 63.345,
            MsTransformOrigin: 63.345,
            transformOrigin: 63.345,
          }}
          id="elof2dklo06mk"
          fill="#263238"
          d="M60.62 426.86H66.07V429.33000000000004H60.62z"
          className="animable"
        ></path>
      </g>
      <defs>
        <filter id="active" height="200%">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="2"
            result="DILATED"
          ></feMorphology>
          <feFlood
            floodColor="#32DFEC"
            floodOpacity="1"
            result="PINK"
          ></feFlood>
          <feComposite
            in="PINK"
            in2="DILATED"
            operator="in"
            result="OUTLINE"
          ></feComposite>
          <feMerge>
            <feMergeNode in="OUTLINE"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
        </filter>
        <filter id="hover" height="200%">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="2"
            result="DILATED"
          ></feMorphology>
          <feFlood floodColor="red" floodOpacity="0.5" result="PINK"></feFlood>
          <feComposite
            in="PINK"
            in2="DILATED"
            operator="in"
            result="OUTLINE"
          ></feComposite>
          <feMerge>
            <feMergeNode in="OUTLINE"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
          <feColorMatrix values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"></feColorMatrix>
        </filter>
      </defs>
    </svg>
  );
}

export default Icon;